"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[5104],{

/***/ 78768:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ billing_BillingProvider),
  "eZ": () => (/* binding */ useBillingCurrency)
});

// UNUSED EXPORTS: useBillingContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/types/index.ts + 12 modules
var types = __webpack_require__(12823);
// EXTERNAL MODULE: ./src/client/utils/constants.ts
var constants = __webpack_require__(20589);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+config-provider@2.1.0_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/config-provider/dist/module.js
var dist_module = __webpack_require__(23198);
;// CONCATENATED MODULE: ./src/client/billing/currencies.ts


const currencyMap = {
  [constants/* TERRITORY.NIGERIA */.jQ.NIGERIA]: {
    format: {
      compact: false,
      locale: "en-NG"
    },
    decimal: 2,
    code: "NGN",
    uuid: "6ae235f2-e345-404a-aab4-4e43f4faac5f"
  },
  [constants/* TERRITORY.LEBANON */.jQ.LEBANON]: {
    format: {
      compact: true,
      locale: "fr-LB"
    },
    decimal: 0,
    code: "LBP",
    uuid: "1ec094ae-eff2-4dfd-b916-a5bc864183df"
  },
  [constants/* TERRITORY.KENYA */.jQ.KENYA]: {
    decimal: 2,
    code: "KES",
    format: {
      compact: true,
      locale: "en-KE"
    },
    uuid: "6d300ea6-8421-4678-88ad-7c33a71bb877"
  },
  [constants/* TERRITORY.PAKISTAN */.jQ.PAKISTAN]: {
    decimal: 2,
    format: {
      compact: false,
      locale: "en-PK"
    },
    code: "PKR",
    uuid: "d38472d2-02e8-437a-b55a-565e19516c8a"
  }
};
function useCurrency() {
  const { territory } = (0,dist_module/* useConfig */.ZR)();
  if (!territory) {
    return void 0;
  }
  return currencyMap[territory];
}

;// CONCATENATED MODULE: ./src/client/billing/BillingProvider.tsx



const BillingContext = react.createContext(null);
const BillingProvider = ({ children }) => {
  const currency = useCurrency();
  const values = {
    error: null,
    refetch: () => {
    },
    currency
  };
  return /* @__PURE__ */ react.createElement(BillingContext.Provider, {
    value: values
  }, children);
};
BillingProvider.propTypes = {
  children: types/* ChildrenType.isRequired */.L5.isRequired
};
const useBillingContext = () => {
  const context = react.useContext(BillingContext);
  if (context === void 0) {
    throw new Error("useBillingContext must be used within a BillingProvider");
  }
  return context;
};
const useBillingCurrency = () => {
  const billingContext = useBillingContext();
  return (0,react.useMemo)(() => {
    const { currency, ...rest } = billingContext;
    return { ...rest, ...currency };
  }, [billingContext]);
};
/* harmony default export */ const billing_BillingProvider = (BillingProvider);


/***/ }),

/***/ 23935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* binding */ printV2Receipt)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/escpos-buffer@2.0.1/node_modules/escpos-buffer/dist/index.js
var dist = __webpack_require__(46721);
// EXTERNAL MODULE: ./node_modules/.pnpm/table@5.4.6/node_modules/table/dist/index.js
var table_dist = __webpack_require__(14208);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/assets/elephant-logo-black-240px_51px.png
var elephant_logo_black_240px_51px = __webpack_require__(13614);
;// CONCATENATED MODULE: ./src/client/billing/printLogo.js


let logo;
async function getLogo() {
  if (!logo) {
    logo = await fetch(elephant_logo_black_240px_51px).then((response) => response.arrayBuffer()).then(
      (buffer) => new Promise((resolve, reject) => {
        new dist.PNG({ filterType: 4 }).parse(buffer, (error, data) => {
          if (error) {
            reject(error);
            return;
          }
          resolve(data);
        });
      })
    ).then((png) => new dist.Image(png));
  }
  return logo;
}

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/formConstants.ts
var formConstants = __webpack_require__(18946);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
;// CONCATENATED MODULE: ./src/client/billing/printV2Receipt.js






async function printClinicDetails(printer, invoice, intl) {
  const { patientType, facility } = invoice;
  const [address] = facility.addresses;
  await printer.writeln(
    facility.name,
    dist.Style.DoubleHeight | dist.Style.Bold,
    dist.Align.Center
  );
  await printer.writeln(
    [address.street, address.subCounty, address.state].join("\n"),
    null,
    dist.Align.Center
  );
  await printer.writeln(
    intl.formatMessage(
      {
        id: "invoices.thermalReceipt.receiptType",
        defaultMessage: "{patientType} payment receipt"
      },
      { patientType }
    ),
    dist.Style.DoubleHeight | dist.Style.Bold,
    dist.Align.Center
  );
  await printer.writeln("");
}
async function printHeader(printer, invoice, intl) {
  var _a, _b, _c, _d, _e, _f;
  await printClinicDetails(printer, invoice, intl);
  const { name } = (_b = (_a = invoice == null ? void 0 : invoice.patient) == null ? void 0 : _a.person) != null ? _b : {};
  await printer.writeln(
    intl.formatMessage(
      {
        id: "invoices.thermalReceipt.patientName",
        defaultMessage: "Patient name: {firstname} {lastname}"
      },
      { firstname: (_c = name == null ? void 0 : name.firstname) != null ? _c : "", lastname: (_d = name == null ? void 0 : name.lastname) != null ? _d : "" }
    )
  );
  const cardId = invoice.patient.cardId || ((_f = (_e = invoice.patient) == null ? void 0 : _e.passport) == null ? void 0 : _f.uid);
  if (cardId) {
    await printer.writeln(
      intl.formatMessage(
        {
          id: "invoices.thermalReceipt.patientId",
          defaultMessage: "Patient ID: {cardId}"
        },
        { cardId }
      )
    );
  }
  await printer.writeln("");
  await printer.writeln(
    intl.formatMessage(
      {
        id: "invoices.thermalReceipt.invoiceNumber",
        defaultMessage: "Invoice number: {invoiceNumber}"
      },
      { invoiceNumber: invoice.invoiceNumber }
    ),
    dist.Style.Bold
  );
  await printer.writeln("");
}
async function printItems(printer, invoice, currencyFormatter, penceToPounds) {
  const { lineItems } = invoice;
  const { columns } = printer;
  const tableData = lineItems.filter((lineItem) => !lineItem.disabled).map((lineItem) => {
    const { priceListItem, quantity, cost } = lineItem;
    return [
      priceListItem.name,
      `x${quantity}`,
      currencyFormatter.format(penceToPounds(cost))
    ];
  });
  const maxLenCurrency = tableData.reduce(
    (max, [, , formattedAmount]) => Math.max(max, formattedAmount.length),
    0
  );
  const paddingRight = 1;
  const qtyWidth = 5;
  const nameWidth = columns - qtyWidth - maxLenCurrency - paddingRight * 3;
  const careEventTable = (0,table_dist/* table */.Kz)(tableData, {
    border: (0,table_dist/* getBorderCharacters */.nf)("void"),
    columnDefault: {
      paddingLeft: 0,
      paddingRight,
      width: columns / 3
    },
    drawHorizontalLine: false,
    columns: {
      0: {
        width: nameWidth
      },
      1: {
        width: qtyWidth,
        alignment: "right"
      },
      2: {
        width: maxLenCurrency,
        alignment: "right"
      }
    }
  });
  await printer.write(careEventTable);
  await printer.writeln(
    Array(printer.columns).fill("_").join(""),
    dist.Style.DoubleHeight | dist.Style.Bold | dist.Style.Underline,
    dist.Align.Center
  );
  await printer.writeln("");
}
async function printTotal(printer, invoice, currencyFormatter, penceToPounds, intl) {
  var _a, _b;
  const { columns } = printer;
  const rightText = currencyFormatter.format(
    penceToPounds(invoice.balance.paid)
  );
  const leftText = intl.formatMessage({
    id: "invoices.thermalReceipt.paid",
    defaultMessage: "Paid"
  });
  const spaceCount = columns - leftText.length - rightText.length;
  const spaces = Array(spaceCount).fill(" ").join("");
  await printer.writeln(
    `${leftText}${spaces}${rightText}`,
    dist.Style.DoubleHeight | dist.Style.Bold
  );
  await printer.writeln("");
  const printPayerTotal = async (name, amount) => {
    const formattedAmount = currencyFormatter.format(penceToPounds(amount));
    const totalSpaces = columns - name.length - formattedAmount.length;
    const serialisedSpaces = Array(totalSpaces).fill(" ").join("");
    await printer.writeln(
      `${name}${serialisedSpaces}${formattedAmount}`,
      dist.Style.DoubleHeight | dist.Style.Bold
    );
  };
  if (((_a = invoice == null ? void 0 : invoice.payers) == null ? void 0 : _a.length) > 0) {
    for (const p of invoice.payers) {
      const name = ((_b = p == null ? void 0 : p.insuranceDetails) == null ? void 0 : _b.name) || p.name;
      const amount = p.balance.paid;
      await printPayerTotal(name, amount);
    }
  }
  const totalWaived = invoice.transactions.filter((t) => t.payer.type === base_gql/* TransactionType.Waiver */.iU.Waiver).reduce((prevVal, curr) => prevVal + curr.amount.value, 0);
  if (totalWaived) {
    await printPayerTotal("Waived", totalWaived);
  }
}
async function printTransactions(printer, transactions, currencyFormatter, penceToPounds, intl) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const filteredTransactions = transactions.filter(
    (t) => t.payer.type !== formConstants/* INSURER */.lj
  );
  if (filteredTransactions.length > 1) {
    await printer.writeln(
      intl.formatMessage(
        {
          id: "invoices.thermalReceipt.transactions",
          defaultMessage: "{length} Transactions"
        },
        { length: filteredTransactions.length }
      ),
      dist.Style.Bold
    );
  }
  for (const tx of filteredTransactions) {
    switch (tx.type) {
      case "PAYMENT":
        await printer.writeln(
          intl.formatMessage(
            {
              id: "invoices.thermalReceipt.paymentType",
              defaultMessage: "Payment type: {type}"
            },
            { type: (_a = tx == null ? void 0 : tx.payment) == null ? void 0 : _a.paymentMethod }
          )
        );
        break;
      case "REFUND":
        await printer.writeln(
          intl.formatMessage(
            {
              id: "invoices.thermalReceipt.paymentType.refund",
              defaultMessage: "Refund type: {type}"
            },
            { type: ((_b = tx == null ? void 0 : tx.payment) == null ? void 0 : _b.paymentMethod) || ((_c = tx == null ? void 0 : tx.refund) == null ? void 0 : _c.paymentMethod) }
          )
        );
        break;
      case "WAIVER":
        await printer.writeln(
          intl.formatMessage({
            id: "invoices.thermalReceipt.paymentType.wavier",
            defaultMessage: "Waiver:"
          })
        );
        break;
      case "EXEMPT":
        await printer.writeln(
          intl.formatMessage({
            id: "invoices.thermalReceipt.paymentType.exempt",
            defaultMessage: "Exempt:"
          })
        );
        break;
      default:
        break;
    }
    if (((_d = tx == null ? void 0 : tx.payment) == null ? void 0 : _d.authCode) || ((_e = tx == null ? void 0 : tx.refund) == null ? void 0 : _e.authCode)) {
      await printer.writeln(
        intl.formatMessage(
          {
            id: "invoices.thermalReceipt.authCode",
            defaultMessage: "Safaricom code: {code}"
          },
          { code: ((_f = tx == null ? void 0 : tx.payment) == null ? void 0 : _f.authCode) || ((_g = tx == null ? void 0 : tx.refund) == null ? void 0 : _g.authCode) }
        )
      );
    }
    if (filteredTransactions.length > 1) {
      await printer.writeln(
        `${currencyFormatter.format(penceToPounds((tx == null ? void 0 : tx.amount.value) || 0))}`
      );
    }
    if (tx.actionedBy) {
      await printer.writeln(
        intl.formatMessage(
          {
            id: "invoices.thermalReceipt.actionedBy",
            defaultMessage: "Served by: {firstname} {lastname}"
          },
          {
            firstname: (_h = tx.actionedBy.person.firstname) != null ? _h : "",
            lastname: (_i = tx.actionedBy.person.lastname) != null ? _i : ""
          }
        )
      );
    }
    await printer.writeln();
  }
}
async function printFooter(printer, invoice, currencyFormatter, penceToPounds, intl) {
  const { created } = invoice;
  await printTransactions(
    printer,
    invoice.transactions,
    currencyFormatter,
    penceToPounds,
    intl
  );
  const timestamp = dayjs_min_default()(created).format("DD/MM/YYYY HH:mm");
  await printer.writeln(
    intl.formatMessage(
      {
        id: "invoices.thermalReceipt.on",
        defaultMessage: "On: {timestamp}"
      },
      { timestamp }
    )
  );
  await printer.writeln("");
  await printer.setAlignment(dist.Align.Center);
  await printer.draw(await getLogo());
  await printer.setAlignment(dist.Align.Left);
}
async function printV2Receipt({
  printer,
  invoice,
  currencyFormatter,
  penceToPounds,
  intl
}) {
  await printHeader(printer, invoice, intl);
  await printItems(printer, invoice, currencyFormatter, penceToPounds, intl);
  await printTotal(printer, invoice, currencyFormatter, penceToPounds, intl);
  await printFooter(printer, invoice, currencyFormatter, penceToPounds, intl);
  await printer.feed(5);
  await printer.cutter();
}


/***/ }),

/***/ 58145:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ clinical_engine_ClinicalEngineDb)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/idb@7.1.1/node_modules/idb/build/index.js + 1 modules
var build = __webpack_require__(56462);
;// CONCATENATED MODULE: ./src/client/clinical-engine/IndexedDbNotReadyError.tsx
class IndexedDbNotReadyError extends Error {
  constructor(accessor) {
    super(`IndexedDb instance accessed before it was ready: ${accessor}`);
  }
}

// EXTERNAL MODULE: ./node_modules/.pnpm/eventemitter3@5.0.0/node_modules/eventemitter3/index.mjs
var eventemitter3 = __webpack_require__(45564);
// EXTERNAL MODULE: ./src/client/clinical-engine/ClinicalEngineDbEvents.tsx
var ClinicalEngineDbEvents = __webpack_require__(8286);
;// CONCATENATED MODULE: ./src/client/clinical-engine/ClinicalEngineDb.tsx




const DB_NAME = "eleClinicalEngine";
class ClinicalEngineDb extends eventemitter3/* default */.Z {
  constructor(config) {
    super();
    this.isInitializing = false;
    this.isReady = false;
    this.isInitializing = true;
    this.emitAnalyticsEvent = config.emitAnalyticsEvent;
    (0,build/* openDB */.X3)(DB_NAME, 2, {
      upgrade: (db) => {
        if (!db.objectStoreNames.contains("masterLists")) {
          db.createObjectStore("masterLists", { keyPath: "name" });
        }
        if (!db.objectStoreNames.contains("syncRequests")) {
          db.createObjectStore("syncRequests", { keyPath: "id" });
        }
      }
    }).then((db) => {
      var _a;
      this.isInitializing = false;
      this.dbConnection = db;
      this.isReady = true;
      this.emit(ClinicalEngineDbEvents/* ClinicalEngineDbEvents.READY */.W.READY);
      (_a = config.onReady) == null ? void 0 : _a.call(config);
    }).catch((err) => {
      this.isInitializing = false;
      this.emit(ClinicalEngineDbEvents/* ClinicalEngineDbEvents.ERROR */.W.ERROR);
      console.error(err);
    });
  }
  get db() {
    if (!this.isReady) {
      throw new Error(
        "Attempting to use db before ready - please use a ready check"
      );
    }
    return this.dbConnection;
  }
  get initializing() {
    return this.isInitializing;
  }
  get dbReady() {
    return this.isReady;
  }
  close() {
    var _a;
    if (this.dbReady) {
      (_a = this.db) == null ? void 0 : _a.close();
    }
  }
  async writeList(name, list, listHash) {
    var _a, _b;
    if (!this.dbReady) {
      console.error("writeList not ready");
      return;
    }
    try {
      const tx = this.db.transaction("masterLists", "readwrite");
      await tx.store.put({
        name,
        result: list,
        listHash: (_b = (_a = list[name]) == null ? void 0 : _a.listHash) != null ? _b : listHash
      });
      await tx.done;
    } catch (error) {
      console.error(error);
    }
  }
  async readList(name) {
    if (!this.dbReady) {
      throw new IndexedDbNotReadyError("readList");
    }
    return this.db.get("masterLists", name);
  }
  async writeSyncRequest(id, request) {
    if (!this.dbReady) {
      throw new IndexedDbNotReadyError("writeSyncRequest");
    }
    const tx = this.db.transaction("syncRequests", "readwrite");
    await tx.store.put({ id, request });
    await tx.done;
    await this.persistStore();
  }
  async readSyncRequest(id) {
    if (!this.dbReady) {
      throw new IndexedDbNotReadyError("readSyncRequest");
    }
    return this.db.get("syncRequests", id);
  }
  async readAllSyncRequests(userId) {
    if (!this.dbReady) {
      throw new IndexedDbNotReadyError("readAllSyncRequests");
    }
    const requests = await this.db.getAll("syncRequests");
    if (userId) {
      return requests.filter((r) => r.request.headers["x-user-id"] === userId);
    }
    return requests;
  }
  async deleteSyncRequest(id) {
    if (!this.dbReady) {
      throw new IndexedDbNotReadyError("deleteSyncRequest");
    }
    const tx = this.db.transaction("syncRequests", "readwrite");
    await tx.store.delete(id);
    await tx.done;
    await this.persistStore();
  }
  async persistStore() {
    var _a;
    try {
      await navigator.storage.persist();
    } catch (e) {
      (_a = this.emitAnalyticsEvent) == null ? void 0 : _a.call(this, {
        name: "ClinicalEngineDb.persist.error",
        category: "clinicalEngine"
      });
    }
  }
}
/* harmony default export */ const clinical_engine_ClinicalEngineDb = (new ClinicalEngineDb({}));


/***/ }),

/***/ 8286:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": () => (/* binding */ ClinicalEngineDbEvents)
/* harmony export */ });
var ClinicalEngineDbEvents = /* @__PURE__ */ ((ClinicalEngineDbEvents2) => {
  ClinicalEngineDbEvents2["READY"] = "ready";
  ClinicalEngineDbEvents2["ERROR"] = "error";
  return ClinicalEngineDbEvents2;
})(ClinicalEngineDbEvents || {});


/***/ }),

/***/ 31798:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);

_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  fragment EncounterPrescriptionFragment on InpatientPrescription {
    id
    createdAt
    note
    asRequired
    status
    prescriber {
      _id
      person {
        firstname
        lastname
      }
    }
    clinicalProduct {
      ... on Vmp {
        title
        id
      }
      ... on Amp {
        title
        id
      }
    }
    dosage {
      unit
      value
    }
    rate {
      unit
      value
    }
    frequency {
      unit
      value
    }
    startsAt
    stopsAt
    dispensations(options: { pageSize: 1, pageNumber: 0 }) {
      items {
        createdAt
        quantity
        alternativeDispensed
        sku {
          name
        }
        dispensedByUser {
          person {
            firstname
            lastname
          }
        }
        dispenseLocation {
          _id
          name
        }
      }
    }
  }
`;
const AncEncounterFragment = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  fragment AncEncounterFragment on AncEncounter {
    id
    createdAt
    updatedAt
    status
    dueDate
    parityDeliveries
    parityMiscarriages
    lastMenstrualPeriod
    ageOfPregnancy
    hivTesting
    femaleGenitalMutilation
    maternalNutrition
    earlyInitiationOfBreastfeeding
    exclusiveBreastfeeding
    syphilisInvestigation
    hepatitisBInvestigation
    hepatitisCInvestigation
    associatedProblems
    visitNumber
    patient {
      uuid
    }
    createdBy {
      _id
      person {
        firstname
        lastname
      }
    }
    clinic {
      name
    }
    investigations {
      ...InvestigationActivityFragment
    }
    prescriptions {
      ...EncounterPrescriptionFragment
    }
  }
`;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  fragment: {
    ancEncounter: AncEncounterFragment
  },
  typename: "AncEncounter"
});


/***/ }),

/***/ 77319:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": () => (/* binding */ ConsultationDataController)
});

// EXTERNAL MODULE: ./src/client/apollo/client.ts + 2 modules
var client = __webpack_require__(77430);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
;// CONCATENATED MODULE: ./src/client/clinical-engine/consultation/data-sync/graphql.ts

const USER_FRAGMENT = lib/* gql */.Ps`
  fragment UserDetails on User {
    _id
    person {
      firstname
      lastname
    }
  }
`;
const PRESCRIPTION_FRAGMENT = lib/* gql */.Ps`
  fragment OutpatientPrescriptionFragment on Prescription {
    uuid
    codification
    note
    dose {
      asNeeded
      doseQuantity {
        value
        unit
      }
      rateQuantity {
        value
        unit
      }
      durationQuantity {
        value
        unit
      }
      codification
    }
    medication {
      uuid
      strength
      formulation
      genericName
      keywords
    }
    encounter
    clinician {
      _id
      person {
        firstname
        lastname
      }
    }
    dispensation {
      status
      quantity
      validityPeriod
      note
      dispensedBy {
        _id
        person {
          firstname
          lastname
        }
      }
      dispensedAtLocation {
        name
      }
      whenHandedOver
      substituteMedication {
        name
      }
    }
  }
`;
const DISEASE_FRAGMENT = lib/* gql */.Ps`
  fragment DiseaseDetails on Disease {
    uuid
    displayName
  }
`;
const CONSULTATION_FRAGMENT = lib/* gql */.Ps`
  fragment ConsultationDetails on Consultation {
    id
    uuid
    clinic
    unit
    clinician
    problem
    presentingComplaint
    location {
      name
    }
    diagnoses {
      id
      code
      codification {
        name
        category
      }
      severity
      note
      onsetDateTime
      uuid
    }
    diseases {
      ...DiseaseDetails
    }
    plan
    patient
    meta {
      created
      active
      persistedAt
    }
    deliveredBy {
      ...UserDetails
    }
    prescriptions {
      ...OutpatientPrescriptionFragment
    }
  }
  ${USER_FRAGMENT}
  ${DISEASE_FRAGMENT}
  ${PRESCRIPTION_FRAGMENT}
`;
const PATIENT_FRAGMENT = lib/* gql */.Ps`
  fragment PatientConsultations on Patient {
    consultations {
      ...ConsultationDetails
    }
  }
  ${CONSULTATION_FRAGMENT}
`;
const MUTATION = lib/* gql */.Ps`
  mutation createConsultation($input: CreateConsultation!, $dryRun: Boolean!) {
    createConsultation(input: $input, dryRun: $dryRun) {
      ...ConsultationDetails
    }
  }
  ${CONSULTATION_FRAGMENT}
`;
/* harmony default export */ const graphql = ({
  mutation: {
    createConsultation: MUTATION
  },
  fragment: {
    disease: DISEASE_FRAGMENT,
    patient: PATIENT_FRAGMENT,
    consultation: CONSULTATION_FRAGMENT,
    user: USER_FRAGMENT
  }
});

// EXTERNAL MODULE: ./src/client/clinical-engine/ClinicalEngineDb.tsx + 1 modules
var ClinicalEngineDb = __webpack_require__(58145);
;// CONCATENATED MODULE: ./src/client/clinical-engine/consultation/data-sync/ConsultationDataController.ts



const LOCAL_STORAGE_KEY = "ele.experiment.consultation.data";
const CONSULTATION_TYPENAME = "Consultation";
class ConsultationDataController {
  static getInstance(apolloClient) {
    if (!this._instance) {
      this._instance = new ConsultationDataController(apolloClient);
    }
    return this._instance;
  }
  constructor(apolloClient) {
    if (!apolloClient) {
      throw new Error(
        "Cannot instantiate ConsultationDataController for first time without apolloClient"
      );
    }
    this.apolloClient = apolloClient;
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  }
  getDataKey(id) {
    if (id.includes(`${CONSULTATION_TYPENAME}:`)) {
      return id;
    }
    return `${CONSULTATION_TYPENAME}:${id}`;
  }
  writeToCache(data, correlationId) {
    const enrichedData = {
      ...data,
      id: correlationId,
      uuid: `temp-${correlationId}`,
      deliveredBy: this.apolloClient.readFragment({
        id: data.deliveredBy.__ref,
        fragment: graphql.fragment.user
      }),
      diseases: data.diseases.map(
        (d) => this.apolloClient.readFragment({
          id: d.__ref,
          fragment: graphql.fragment.disease
        })
      )
    };
    const id = `${(0,client/* customDataIdFromObject */.Ux)(enrichedData)}`;
    this.apolloClient.writeFragment({
      data: enrichedData,
      fragment: graphql.fragment.consultation,
      fragmentName: "ConsultationDetails",
      id
    });
    const patientFragmentId = `Patient:${data.patient}`;
    this.apolloClient.cache.updateFragment(
      {
        id: patientFragmentId,
        fragment: graphql.fragment.patient,
        fragmentName: "PatientConsultations"
      },
      (patientCacheData) => {
        return {
          ...patientCacheData,
          consultations: [enrichedData, ...patientCacheData.consultations]
        };
      }
    );
  }
  readFromCache(cacheKey, _correlationId) {
    return this.apolloClient.readFragment({
      fragment: graphql.fragment.consultation,
      id: this.getDataKey(cacheKey)
    });
  }
  deleteFromCache(cacheKey, _correlationId) {
    return this.apolloClient.cache.evict({ id: this.getDataKey(cacheKey) });
  }
  async writeToStore(storeKey, variables, syncDetails, headers) {
    return ClinicalEngineDb/* default.writeSyncRequest */.Z.writeSyncRequest(storeKey, { syncDetails, headers, variables });
  }
  async readFromStore(storeKey, _correlationId) {
    return ClinicalEngineDb/* default.readSyncRequest */.Z.readSyncRequest(storeKey);
  }
  async readAllFromStore(userId) {
    return ClinicalEngineDb/* default.readAllSyncRequests */.Z.readAllSyncRequests(userId);
  }
  async deleteFromStore(storeKey, _correlationId) {
    return ClinicalEngineDb/* default.deleteSyncRequest */.Z.deleteSyncRequest(storeKey);
  }
}



/***/ }),

/***/ 40305:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lv": () => (/* binding */ UserDetailsFragmentDoc),
/* harmony export */   "Wo": () => (/* binding */ CreateConsultationDocument),
/* harmony export */   "Yv": () => (/* binding */ useCreateConsultationMutation),
/* harmony export */   "f1": () => (/* binding */ OutpatientPrescriptionFragmentFragmentDoc),
/* harmony export */   "u_": () => (/* binding */ DiseaseDetailsFragmentDoc)
/* harmony export */ });
/* unused harmony exports ConsultationDetailsFragmentDoc, PatientConsultationsFragmentDoc */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28205);


const defaultOptions = {};
const DiseaseDetailsFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    fragment DiseaseDetails on Disease {
  uuid
  displayName
}
    `;
const UserDetailsFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    fragment UserDetails on User {
  _id
  person {
    firstname
    lastname
  }
}
    `;
const OutpatientPrescriptionFragmentFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    fragment OutpatientPrescriptionFragment on Prescription {
  uuid
  codification
  note
  dose {
    asNeeded
    doseQuantity {
      value
      unit
    }
    rateQuantity {
      value
      unit
    }
    durationQuantity {
      value
      unit
    }
    codification
  }
  medication {
    uuid
    strength
    formulation
    genericName
    keywords
  }
  encounter
  clinician {
    _id
    person {
      firstname
      lastname
    }
  }
  dispensation {
    status
    quantity
    validityPeriod
    note
    dispensedBy {
      _id
      person {
        firstname
        lastname
      }
    }
    dispensedAtLocation {
      name
    }
    whenHandedOver
    substituteMedication {
      name
    }
  }
}
    `;
const ConsultationDetailsFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    fragment ConsultationDetails on Consultation {
  id
  uuid
  clinic
  unit
  clinician
  problem
  presentingComplaint
  location {
    name
  }
  diagnoses {
    id
    code
    codification {
      name
      category
    }
    severity
    note
    onsetDateTime
    uuid
  }
  diseases {
    ...DiseaseDetails
  }
  plan
  patient
  meta {
    created
    active
    persistedAt
  }
  deliveredBy {
    ...UserDetails
  }
  prescriptions {
    ...OutpatientPrescriptionFragment
  }
}
    ${DiseaseDetailsFragmentDoc}
${UserDetailsFragmentDoc}
${OutpatientPrescriptionFragmentFragmentDoc}`;
const PatientConsultationsFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    fragment PatientConsultations on Patient {
  consultations {
    ...ConsultationDetails
  }
}
    ${ConsultationDetailsFragmentDoc}`;
const CreateConsultationDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    mutation createConsultation($input: CreateConsultation!, $dryRun: Boolean!) {
  createConsultation(input: $input, dryRun: $dryRun) {
    ...ConsultationDetails
  }
}
    ${ConsultationDetailsFragmentDoc}`;
function useCreateConsultationMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateConsultationDocument, options);
}


/***/ }),

/***/ 65012:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SW": () => (/* binding */ SUBMIT_LATER_NAME),
/* harmony export */   "X6": () => (/* binding */ SUBMIT_LATER_EVENT),
/* harmony export */   "lD": () => (/* binding */ SUBMIT_LATER_CATEGORY)
/* harmony export */ });
const SUBMIT_LATER_NAME = "newConsultation.submitLater";
const SUBMIT_LATER_CATEGORY = "experiment.submitLater";
var SUBMIT_LATER_EVENT = /* @__PURE__ */ ((SUBMIT_LATER_EVENT2) => {
  SUBMIT_LATER_EVENT2["scheduleFail"] = "schedule.fail";
  SUBMIT_LATER_EVENT2["submit"] = "submit.attempt";
  SUBMIT_LATER_EVENT2["success"] = "submit.success";
  SUBMIT_LATER_EVENT2["failure"] = "submit.failure";
  return SUBMIT_LATER_EVENT2;
})(SUBMIT_LATER_EVENT || {});


/***/ }),

/***/ 79042:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ getPatientHistoryCacheUpdateFunction)
/* harmony export */ });
/* harmony import */ var _components_PatientOverview_Tabs_History_generated_index_gql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39551);

const getPatientHistoryCacheUpdateFunction = (patientUuid, searchWholeTerritory) => (cache, { data }) => {
  cache.updateQuery(
    {
      query: _components_PatientOverview_Tabs_History_generated_index_gql__WEBPACK_IMPORTED_MODULE_0__/* .GetPatientConsultationsDocument */ .HG,
      variables: { patientUuid, searchWholeTerritory }
    },
    (cacheResult) => {
      try {
        const { patientByCardId } = cacheResult;
        return {
          patientByCardId: {
            ...patientByCardId,
            patient: {
              ...patientByCardId.patient,
              consultations: [
                ...patientByCardId.patient.consultations,
                data.createConsultation
              ]
            }
          }
        };
      } catch (e) {
      }
      return cacheResult;
    }
  );
};


/***/ }),

/***/ 80084:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ ClinicalEventController),
/* harmony export */   "a": () => (/* binding */ FailureSeverity)
/* harmony export */ });
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45564);
/* harmony import */ var _clinicalActivityStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40802);
/* harmony import */ var _ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73133);



var FailureSeverity = /* @__PURE__ */ ((FailureSeverity2) => {
  FailureSeverity2["FATAL"] = "FATAL";
  FailureSeverity2["ACCEPTABLE"] = "ACCEPTABLE";
  return FailureSeverity2;
})(FailureSeverity || {});
class ClinicalEventController extends eventemitter3__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor() {
    super();
    this.pendingListenersMap = {
      [_ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__/* .ClinicalTopics.CONSULTATION */ .V.CONSULTATION]: []
    };
    this.failureListenersMap = {
      [_ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__/* .ClinicalTopics.CONSULTATION */ .V.CONSULTATION]: []
    };
    this.successListenersMap = {
      [_ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__/* .ClinicalTopics.CONSULTATION */ .V.CONSULTATION]: []
    };
    this.addListener(_ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__/* .ClinicalTopics.CONSULTATION */ .V.CONSULTATION, this.onConsultationEvent);
  }
  static getInstance() {
    if (!this._instance) {
      this._instance = new ClinicalEventController();
    }
    return this._instance;
  }
  emit(event, data) {
    return super.emit(event, data);
  }
  registerPendingListener(topic, listener) {
    this.pendingListenersMap[topic].push(listener);
  }
  registerFailureListener(topic, listener) {
    this.failureListenersMap[topic].push(listener);
  }
  registerSuccessListener(topic, listener) {
    this.successListenersMap[topic].push(listener);
  }
  onConsultationEvent(event) {
    switch (event.status) {
      case _clinicalActivityStatus__WEBPACK_IMPORTED_MODULE_1__/* .ClinicalActivityStatus.pending */ .y.pending:
        this.pendingListenersMap[_ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__/* .ClinicalTopics.CONSULTATION */ .V.CONSULTATION].forEach(
          (fn) => fn(event).catch(console.warn)
        );
        break;
      case _clinicalActivityStatus__WEBPACK_IMPORTED_MODULE_1__/* .ClinicalActivityStatus.fail */ .y.fail:
        this.failureListenersMap[_ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__/* .ClinicalTopics.CONSULTATION */ .V.CONSULTATION].forEach(
          (fn) => fn(event).catch(console.warn)
        );
        break;
      case _clinicalActivityStatus__WEBPACK_IMPORTED_MODULE_1__/* .ClinicalActivityStatus.success */ .y.success:
        this.successListenersMap[_ClinicalTopics__WEBPACK_IMPORTED_MODULE_2__/* .ClinicalTopics.CONSULTATION */ .V.CONSULTATION].forEach(
          (fn) => fn(event).catch(console.warn)
        );
        break;
      default:
        console.warn("Unhandled Clinical event");
        break;
    }
  }
}



/***/ }),

/***/ 75185:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OX": () => (/* binding */ ClinicalSyncStatusProvider),
  "Tb": () => (/* binding */ useClinicalSyncStatusContext)
});

// UNUSED EXPORTS: ClinicalSyncStatusContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/clinicalActivityStatus.ts
var clinicalActivityStatus = __webpack_require__(40802);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/index.ts + 1 modules
var data_sync = __webpack_require__(19545);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/ClinicalEventController.ts
var ClinicalEventController = __webpack_require__(80084);
// EXTERNAL MODULE: ./src/client/utils/useUser.ts
var useUser = __webpack_require__(91019);
// EXTERNAL MODULE: ./src/client/clinical-engine/ClinicalEngineDb.tsx + 1 modules
var ClinicalEngineDb = __webpack_require__(58145);
// EXTERNAL MODULE: ./src/client/clinical-engine/ClinicalEngineDbEvents.tsx
var ClinicalEngineDbEvents = __webpack_require__(8286);
;// CONCATENATED MODULE: ./src/client/clinical-engine/useClinicalEngineDbReady.ts



function useClinicalEngineDbReady() {
  const [isReady, setReady] = (0,react.useState)(ClinicalEngineDb/* default.dbReady */.Z.dbReady);
  (0,react.useEffect)(() => {
    const handleReady = () => setReady(true);
    const handleError = () => setReady(false);
    ClinicalEngineDb/* default.on */.Z.on(ClinicalEngineDbEvents/* ClinicalEngineDbEvents.READY */.W.READY, handleReady);
    ClinicalEngineDb/* default.on */.Z.on(ClinicalEngineDbEvents/* ClinicalEngineDbEvents.ERROR */.W.ERROR, handleError);
    return () => {
      ClinicalEngineDb/* default.off */.Z.off(ClinicalEngineDbEvents/* ClinicalEngineDbEvents.READY */.W.READY, handleReady);
      ClinicalEngineDb/* default.off */.Z.off(ClinicalEngineDbEvents/* ClinicalEngineDbEvents.ERROR */.W.ERROR, handleError);
    };
  }, []);
  return isReady;
}
/* harmony default export */ const clinical_engine_useClinicalEngineDbReady = (useClinicalEngineDbReady);

// EXTERNAL MODULE: ./src/client/auth/SigningTokenProvider/SigningTokenProvider.tsx + 1 modules
var SigningTokenProvider = __webpack_require__(48462);
;// CONCATENATED MODULE: ./src/client/clinical-engine/data-sync/ClinicalSyncStatus.tsx








const ClinicalSyncStatusContext = react.createContext({
  canPerformOfflineOperations: false
});
const ClinicalSyncStatusProvider = ({
  children
}) => {
  const { userId } = (0,useUser/* useLazyUser */.x)();
  const [syncStatus, setSyncStatusState] = react.useState({});
  const { signingToken } = (0,SigningTokenProvider/* useSigningTokenContext */.M_)();
  const dbReady = clinical_engine_useClinicalEngineDbReady();
  const canPerformOfflineOperations = !!signingToken && dbReady;
  react.useEffect(() => {
    ClinicalEngineDb/* default.readAllSyncRequests */.Z.readAllSyncRequests(userId).then((res) => {
      setSyncStatusState(
        res.reduce((acc, next) => {
          acc[next.id] = next.request.syncDetails;
          return acc;
        }, {})
      );
    });
  }, [userId]);
  const addSyncStatus = react.useCallback(
    (status) => {
      setSyncStatusState((curr) => {
        const newState = {
          ...curr,
          [status.key]: { ...status, data: status.data }
        };
        return newState;
      });
    },
    [setSyncStatusState]
  );
  const clearSyncStatus = react.useCallback(
    (key) => {
      setSyncStatusState((curr) => {
        const { [key]: _, ...newState } = curr;
        return newState;
      });
    },
    [setSyncStatusState]
  );
  const handleEvent = react.useCallback(
    (eventData) => {
      switch (eventData.status) {
        case clinicalActivityStatus/* ClinicalActivityStatus.pending */.y.pending:
          addSyncStatus(eventData);
          break;
        case clinicalActivityStatus/* ClinicalActivityStatus.success */.y.success:
          clearSyncStatus(eventData.key);
          break;
        default:
          break;
      }
      return () => {
      };
    },
    [addSyncStatus, clearSyncStatus]
  );
  react.useEffect(() => {
    ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance().addListener(
      data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
      handleEvent
    );
    return () => {
    };
  }, [handleEvent]);
  const value = react.useMemo(
    () => ({
      data: syncStatus,
      addSyncStatus,
      clearSyncStatus,
      canPerformOfflineOperations
    }),
    [syncStatus, addSyncStatus, clearSyncStatus, canPerformOfflineOperations]
  );
  return /* @__PURE__ */ react.createElement(ClinicalSyncStatusContext.Provider, {
    value
  }, children);
};
const useClinicalSyncStatusContext = () => {
  const context = (0,react.useContext)(ClinicalSyncStatusContext);
  if (context === void 0) {
    throw new Error(
      "useClinicalSyncStatusContext must be used within a ClinicalSyncStatusProvider"
    );
  }
  return context;
};



/***/ }),

/***/ 73133:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ ClinicalTopics)
/* harmony export */ });
var ClinicalTopics = /* @__PURE__ */ ((ClinicalTopics2) => {
  ClinicalTopics2["CONSULTATION"] = "CONSULTATION";
  return ClinicalTopics2;
})(ClinicalTopics || {});


/***/ }),

/***/ 49173:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ userIdHeader),
/* harmony export */   "x": () => (/* binding */ requestSignatureHeader)
/* harmony export */ });
const requestSignatureHeader = "x-request-signature";
const userIdHeader = "x-user-id";



/***/ }),

/***/ 40802:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ ClinicalActivityStatus)
/* harmony export */ });
var ClinicalActivityStatus = /* @__PURE__ */ ((ClinicalActivityStatus2) => {
  ClinicalActivityStatus2["pending"] = "PENDING";
  ClinicalActivityStatus2["success"] = "SUCCESS";
  ClinicalActivityStatus2["fail"] = "FAIL";
  return ClinicalActivityStatus2;
})(ClinicalActivityStatus || {});


/***/ }),

/***/ 71818:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ UnauthorizedError)
/* harmony export */ });
class UnauthorizedError extends Error {
  constructor(message) {
    super(message);
    this.name = "UnauthorizedError";
  }
}


/***/ }),

/***/ 19545:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": () => (/* reexport */ ClinicalTopics/* ClinicalTopics */.V),
  "at": () => (/* reexport */ ClinicalEventController/* FailureSeverity */.a),
  "dR": () => (/* reexport */ NotFoundError),
  "yj": () => (/* reexport */ UnauthorizedError/* UnauthorizedError */.y)
});

// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/ClinicalTopics.ts
var ClinicalTopics = __webpack_require__(73133);
;// CONCATENATED MODULE: ./src/client/clinical-engine/data-sync/error/NotFoundError.ts
class NotFoundError extends Error {
  constructor(message) {
    super(message);
    this.name = "NotFoundError";
  }
}

// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/error/UnauthorizedError.ts
var UnauthorizedError = __webpack_require__(71818);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/ClinicalEventController.ts
var ClinicalEventController = __webpack_require__(80084);
;// CONCATENATED MODULE: ./src/client/clinical-engine/data-sync/index.ts







/***/ }),

/***/ 76906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": () => (/* binding */ useActiveDiseasesQuery),
/* harmony export */   "HG": () => (/* binding */ useActiveDiseasesLazyQuery),
/* harmony export */   "b4": () => (/* binding */ ActiveDiseasesDocument),
/* harmony export */   "vO": () => (/* binding */ useDiseaseListHashQuery)
/* harmony export */ });
/* unused harmony exports DiseaseListHashDocument, useDiseaseListHashLazyQuery */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41552);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90322);


const defaultOptions = {};
const ActiveDiseasesDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query ActiveDiseases {
  diseases {
    id
    items {
      uuid
      category
      code
      coding
      categoryDisplayName
      displayName
      keywords
    }
    categoryItems {
      displayName
      value
    }
    listHash
  }
}
    `;
function useActiveDiseasesQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a(ActiveDiseasesDocument, options);
}
function useActiveDiseasesLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useLazyQuery */ .t(ActiveDiseasesDocument, options);
}
const DiseaseListHashDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query DiseaseListHash {
  diseaseListHash
}
    `;
function useDiseaseListHashQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a(DiseaseListHashDocument, options);
}
function useDiseaseListHashLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(DiseaseListHashDocument, options);
}


/***/ }),

/***/ 62604:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": () => (/* binding */ useDiseases),
/* harmony export */   "m": () => (/* binding */ CREATE_CONSULTATION_ROLES)
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79226);
/* harmony import */ var _generated_useDiseases_gql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76906);
/* harmony import */ var _elephant_healthcare_role_definitions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4377);
/* harmony import */ var _elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36547);
/* harmony import */ var _ClinicalEngineDb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93236);






const { CLINIC, DOCTOR, ELEPHANT, NURSE, ROOT } = _elephant_healthcare_role_definitions__WEBPACK_IMPORTED_MODULE_1__/* .Role */ .uU;
_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps`
  query ActiveDiseases {
    diseases {
      id
      items {
        uuid
        category
        code
        coding
        categoryDisplayName
        displayName
        keywords
      }
      categoryItems {
        displayName
        value
      }
      listHash
    }
  }
`;
_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps`
  query DiseaseListHash {
    diseaseListHash
  }
`;
const CREATE_CONSULTATION_ROLES = [
  CLINIC,
  DOCTOR,
  ELEPHANT,
  NURSE,
  ROOT
];
const useDiseases = () => {
  const { roleName } = (0,_elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_2__/* .useUserContext */ .SE)();
  const apollo = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useApolloClient */ .x)();
  const skip = !(0,_elephant_healthcare_role_definitions__WEBPACK_IMPORTED_MODULE_1__/* .roleIsInRoles */ .a3)(roleName, CREATE_CONSULTATION_ROLES);
  const [queryDiseases] = (0,_generated_useDiseases_gql__WEBPACK_IMPORTED_MODULE_0__/* .useActiveDiseasesLazyQuery */ .HG)({
    onCompleted: async (data2) => {
      await _ClinicalEngineDb__WEBPACK_IMPORTED_MODULE_3__/* ["default"].writeList */ .Z.writeList("diseases", data2);
    },
    fetchPolicy: "network-only"
  });
  const { data } = (0,_generated_useDiseases_gql__WEBPACK_IMPORTED_MODULE_0__/* .useDiseaseListHashQuery */ .vO)({
    skip,
    pollInterval: 1e3 * 60 * 60
  });
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    const fn = async () => {
      try {
        const res = await _ClinicalEngineDb__WEBPACK_IMPORTED_MODULE_3__/* ["default"].readList */ .Z.readList("diseases");
        if (res && !(data == null ? void 0 : data.diseaseListHash)) {
          apollo.writeQuery({
            query: _generated_useDiseases_gql__WEBPACK_IMPORTED_MODULE_0__/* .ActiveDiseasesDocument */ .b4,
            data: res.result
          });
        } else if (!res || res && res.listHash !== (data == null ? void 0 : data.diseaseListHash)) {
          queryDiseases();
        }
      } catch (e) {
        console.error(e);
        queryDiseases();
      }
    };
    if (!skip) {
      fn();
    }
  }, [skip, data == null ? void 0 : data.diseaseListHash]);
  return null;
};


/***/ }),

/***/ 15914:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ClinicalEngine)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(79226);
// EXTERNAL MODULE: ./src/client/patient-triage/types.ts
var types = __webpack_require__(37231);
// EXTERNAL MODULE: ./src/client/patient-triage/useTriageStatus.tsx
var useTriageStatus = __webpack_require__(58011);
// EXTERNAL MODULE: ./src/client/ward-patient-list/queries.ts
var queries = __webpack_require__(50215);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
// EXTERNAL MODULE: ./src/client/api/endpoints.js
var endpoints = __webpack_require__(43750);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./src/client/apollo/client.ts + 2 modules
var client = __webpack_require__(77430);
// EXTERNAL MODULE: ./src/client/apollo/RetryApolloContext.tsx
var RetryApolloContext = __webpack_require__(92560);
// EXTERNAL MODULE: ./src/client/utils/handleEventsourceDisconnect.ts
var handleEventsourceDisconnect = __webpack_require__(72769);
// EXTERNAL MODULE: ./src/client/patient-triage/useScheduleTriageExpiry.tsx
var useScheduleTriageExpiry = __webpack_require__(95316);
// EXTERNAL MODULE: ./src/client/auth/SessionTokenProvider/SessionTokenProvider.tsx
var SessionTokenProvider = __webpack_require__(1767);
;// CONCATENATED MODULE: ./src/client/clinical-engine/patient-triage/index.ts












const useWardsQuery = (apolloClient) => {
  const [resultState, setResultState] = react.useState();
  const { facilityId: clinicUuid } = (0,dist_module/* useUserContext */.SE)();
  react.useEffect(() => {
    if (!clinicUuid)
      return;
    async function fetchData() {
      if (!clinicUuid)
        return;
      try {
        const { data: wardData } = await apolloClient.query({
          query: queries/* WARD_AND_PATIENT_QUERY */.Y,
          variables: { clinicUuid }
        });
        const triageQueryVariables = {
          patientUuids: wardData == null ? void 0 : wardData.facilityLocations.flatMap(
            (l) => l.patients.map((p) => p.uuid)
          )
        };
        const result = await apolloClient.query({
          query: queries/* PATIENT_TRIAGE_STATUSES */.r,
          variables: triageQueryVariables
        });
        const { data: triageData } = result;
        if (!(triageData == null ? void 0 : triageData.patientTriageStatuses.length))
          return;
        setResultState({
          queryResult: result,
          getTriageObservable: () => apolloClient.watchQuery({
            query: queries/* PATIENT_TRIAGE_STATUSES */.r,
            variables: triageQueryVariables
          }),
          getWardsObservable: () => apolloClient.watchQuery({
            query: queries/* WARD_AND_PATIENT_QUERY */.Y,
            variables: { clinicUuid }
          })
        });
      } catch (error) {
        if (error.message.toLowerCase().includes("does not have access") || error.message.toLowerCase().includes("unauth")) {
        }
      }
    }
    fetchData();
  }, [clinicUuid]);
  return resultState;
};
function transformTriageStatusData(triageData) {
  var _a, _b;
  return {
    _id: triageData.triageId,
    clinicUuid: triageData.clinicId,
    patientUuid: triageData.patientId,
    currentStatus: triageData.currentStatus,
    expiresAt: triageData.expiresAt,
    createdAt: (_a = triageData.createdAt) != null ? _a : new Date().toISOString(),
    updatedAt: (_b = triageData.updatedAt) != null ? _b : null,
    __typename: "TriageStatus"
  };
}
const handleTriageStatusData = (triageData, apolloClient, triageObservableQuery, wardObservableQuery) => {
  var _a, _b, _c;
  try {
    if (triageData.currentStatus === base_gql/* TriageStatusType.None */.lc.None) {
      apolloClient.cache.evict({
        id: apolloClient.cache.identify(triageData)
      });
      apolloClient.cache.gc();
      return;
    }
    apolloClient.writeFragment({
      data: triageData,
      fragment: useTriageStatus/* PatientTriageStatusFragment */.J6,
      id: (0,client/* customDataIdFromObject */.Ux)(triageData)
    });
    const wardsRes = wardObservableQuery.getCurrentResult();
    const patientUuids = (_b = (_a = wardsRes == null ? void 0 : wardsRes.data) == null ? void 0 : _a.facilityLocations) == null ? void 0 : _b.flatMap(
      (l) => l.patients.map((p) => p.uuid)
    );
    if (!patientUuids.includes(triageData.patientUuid))
      return;
    const triageRes = triageObservableQuery.getCurrentResult();
    const { data } = triageRes;
    const statuses = (_c = data.patientTriageStatuses) != null ? _c : [];
    const existingIndex = statuses.findIndex(
      (s) => s.patientUuid === triageData.patientUuid
    );
    const withoutExisting = existingIndex > -1 ? [
      ...statuses.slice(0, existingIndex),
      ...statuses.slice(existingIndex + 1)
    ] : statuses;
    const mergedStatus = existingIndex ? { ...statuses[existingIndex], ...triageData } : triageData;
    const enrichedStatuses = [...withoutExisting, mergedStatus];
    apolloClient.writeQuery({
      data: { patientTriageStatuses: enrichedStatuses },
      query: queries/* PATIENT_TRIAGE_STATUSES */.r,
      variables: { patientUuids }
    });
  } catch (error) {
  }
};
function onTriageStatus(event, client, triageObservableQuery, wardObservableQuery) {
  const { data } = event;
  const parsedData = JSON.parse(data);
  const triage = transformTriageStatusData(parsedData);
  handleTriageStatusData(
    triage,
    client,
    triageObservableQuery,
    wardObservableQuery
  );
  return triage;
}
const usePatientTriageEvents = async () => {
  var _a, _b;
  const apolloClient = (0,RetryApolloContext/* useRetryApolloClient */.M)();
  const clinicalSubscriptionServiceUrl = (0,endpoints/* default */.Z)().clinicalSubscriptionServicePath;
  const wardsQuery = useWardsQuery(apolloClient);
  const scheduleTriageExpiry = (0,useScheduleTriageExpiry/* useScheduleTriageExpiry */.y)();
  react.useEffect(() => {
    var _a2, _b2;
    const statuses = (_b2 = (_a2 = wardsQuery == null ? void 0 : wardsQuery.queryResult) == null ? void 0 : _a2.data) == null ? void 0 : _b2.patientTriageStatuses;
    if (statuses == null ? void 0 : statuses.length) {
      statuses.forEach((s) => scheduleTriageExpiry(s));
    }
  }, [
    (_b = (_a = wardsQuery == null ? void 0 : wardsQuery.queryResult) == null ? void 0 : _a.data) == null ? void 0 : _b.patientTriageStatuses,
    scheduleTriageExpiry
  ]);
  const { sessionToken: token } = (0,SessionTokenProvider/* useSessionTokenContext */.ic)();
  react.useEffect(() => {
    if (!wardsQuery)
      return () => {
      };
    const { getTriageObservable, getWardsObservable } = wardsQuery;
    const triageObservableQuery = getTriageObservable();
    const wardObservableQuery = getWardsObservable();
    const onMessage = (event) => {
      const triage = onTriageStatus(
        event,
        apolloClient,
        triageObservableQuery,
        wardObservableQuery
      );
      if (triage) {
        scheduleTriageExpiry(triage);
      }
    };
    const triageEs = new EventSource(
      `${clinicalSubscriptionServiceUrl}events/triage?token=${token}`
    );
    triageEs.addEventListener(types/* EventTypes.CREATED */.G.CREATED, onMessage);
    triageEs.addEventListener(types/* EventTypes.UPDATED */.G.UPDATED, onMessage);
    (0,handleEventsourceDisconnect/* handleEventsourceDisconnect */.V)({
      es: triageEs,
      refetch: triageObservableQuery.refetch,
      errorName: "EventSource.error.clinical-engine.patient-triage"
    });
    return () => {
      triageEs.close();
    };
  }, [
    wardsQuery,
    apolloClient,
    scheduleTriageExpiry,
    clinicalSubscriptionServiceUrl,
    token
  ]);
};

// EXTERNAL MODULE: ./src/client/clinical-engine/diseases/useDiseases.tsx
var useDiseases = __webpack_require__(62604);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var role_definitions_dist_module = __webpack_require__(4377);
// EXTERNAL MODULE: ./src/client/clinical-engine/medications/__generated__/useMedications.gql.ts
var useMedications_gql = __webpack_require__(80540);
// EXTERNAL MODULE: ./src/client/clinical-engine/ClinicalEngineDb.tsx + 1 modules
var ClinicalEngineDb = __webpack_require__(58145);
;// CONCATENATED MODULE: ./src/client/clinical-engine/medications/useMedications.tsx






const { ADMIN, DOCTOR, ELEPHANT, NURSE, ROOT } = role_definitions_dist_module/* Role */.uU;
lib/* gql */.Ps`
  query ActiveMedications {
    medications {
      id
      items {
        id
        uuid
        genericName
        formulation
        strength
        keywords
      }
      listHash
    }
  }
`;
lib/* gql */.Ps`
  query MedicationListHash {
    medicationListHash
  }
`;
const CREATE_CONSULTATION_ROLES = [ADMIN, DOCTOR, ELEPHANT, NURSE, ROOT];
const useMedications = () => {
  const { roleName } = (0,dist_module/* useUserContext */.SE)();
  const apollo = (0,useApolloClient/* useApolloClient */.x)();
  const skip = !(0,role_definitions_dist_module/* roleIsInRoles */.a3)(roleName, CREATE_CONSULTATION_ROLES);
  const [queryMedications] = (0,useMedications_gql/* useActiveMedicationsLazyQuery */.mu)({
    onCompleted: async (data2) => {
      await ClinicalEngineDb/* default.writeList */.Z.writeList("medications", data2);
    },
    fetchPolicy: "network-only"
  });
  const { data } = (0,useMedications_gql/* useMedicationListHashQuery */.Wp)({
    skip,
    pollInterval: 1e3 * 60 * 60
  });
  (0,react.useEffect)(() => {
    const fn = async () => {
      try {
        const res = await ClinicalEngineDb/* default.readList */.Z.readList("medications");
        if (res && !(data == null ? void 0 : data.medicationListHash)) {
          apollo.writeQuery({
            query: useMedications_gql/* ActiveMedicationsDocument */.L,
            data: res.result
          });
        } else if (!res || res && res.listHash !== (data == null ? void 0 : data.medicationListHash)) {
          queryMedications();
        }
      } catch (e) {
        console.error(e);
        queryMedications();
      }
    };
    if (!skip) {
      fn();
    }
  }, [skip, data == null ? void 0 : data.medicationListHash]);
  return null;
};

// EXTERNAL MODULE: ./src/client/clinical-engine/investigationActivities/__generated__/useInvestigationActivities.gql.ts
var useInvestigationActivities_gql = __webpack_require__(76361);
// EXTERNAL MODULE: ./src/client/clinical-engine/investigationActivities/data-sync/InvestigationDataController.ts + 2 modules
var InvestigationDataController = __webpack_require__(34176);
;// CONCATENATED MODULE: ./src/client/clinical-engine/investigationActivities/useInvestigationActivities.tsx







const { DOCTOR: useInvestigationActivities_DOCTOR, NURSE: useInvestigationActivities_NURSE, TECHNICIAN } = role_definitions_dist_module/* Role */.uU;
lib/* gql */.Ps`
  query ActiveInvestigationActivities {
    catalogueInvestigationActivities {
      id
      _id
      title
      keywords
      activityType
      meta {
        created
      }
      coding {
        elephant {
          code
        }
        loinc {
          code
        }
      }
      result {
        resultSchema
      }
    }
  }
`;
lib/* gql */.Ps`
  query InvestigationsListHash {
    catalogueInvestigationActivitiesLastUpdated
  }
`;
const REQUEST_INVESTIGATION_ROLES = [useInvestigationActivities_DOCTOR, useInvestigationActivities_NURSE, TECHNICIAN];
function getLastUpdated(data) {
  try {
    return [...data.catalogueInvestigationActivities].sort((a, b) => {
      return new Date(b.meta.created).getTime() - new Date(a.meta.created).getTime();
    })[0].meta.created;
  } catch {
    return new Date().toISOString();
  }
}
const useInvestigationActivities = () => {
  const { roleName } = (0,dist_module/* useUserContext */.SE)();
  const apollo = (0,useApolloClient/* useApolloClient */.x)();
  InvestigationDataController/* InvestigationDataController.getInstance */.o.getInstance(apollo);
  const skip = !(0,role_definitions_dist_module/* roleIsInRoles */.a3)(roleName, REQUEST_INVESTIGATION_ROLES);
  const [queryInvestigations] = (0,useInvestigationActivities_gql/* useActiveInvestigationActivitiesLazyQuery */.eW)({
    onCompleted: async (data2) => {
      await ClinicalEngineDb/* default.writeList */.Z.writeList("investigationActivities", data2, getLastUpdated(data2));
    },
    fetchPolicy: "network-only"
  });
  const { data } = (0,useInvestigationActivities_gql/* useInvestigationsListHashQuery */.oG)({
    skip,
    pollInterval: 1e3 * 60 * 60
  });
  (0,react.useEffect)(() => {
    const fn = async () => {
      try {
        const res = await ClinicalEngineDb/* default.readList */.Z.readList("investigationActivities");
        if (res && !(data == null ? void 0 : data.catalogueInvestigationActivitiesLastUpdated)) {
          apollo.writeQuery({
            query: useInvestigationActivities_gql/* ActiveInvestigationActivitiesDocument */.yG,
            data: res.result
          });
        } else if (!res || res && res.listHash !== (data == null ? void 0 : data.catalogueInvestigationActivitiesLastUpdated)) {
          queryInvestigations();
        }
      } catch (e) {
        console.error(e);
        queryInvestigations();
      }
    };
    if (!skip) {
      fn();
    }
  }, [skip, data == null ? void 0 : data.catalogueInvestigationActivitiesLastUpdated]);
  return null;
};

// EXTERNAL MODULE: ./src/client/clinical-engine/consultation/data-sync/__generated__/graphql.gql.ts
var graphql_gql = __webpack_require__(40305);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(4290);
;// CONCATENATED MODULE: ./src/client/clinical-engine/data-sync/error/BadUserInputError.ts
class BadUserInputError extends Error {
  constructor(message) {
    super(message);
    this.name = "BadUserInputError";
  }
}

// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/error/UnauthorizedError.ts
var UnauthorizedError = __webpack_require__(71818);
;// CONCATENATED MODULE: ./src/client/clinical-engine/data-sync/error/RequestSignatureError.ts
class RequestSignatureError extends Error {
  constructor(message, code) {
    super(message);
    this.name = "RequestSignatureError";
    this.code = code;
  }
}

;// CONCATENATED MODULE: ./src/client/clinical-engine/data-sync/error/extractAndNormalizeApolloError.ts



const normalizeError = (error) => {
  var _a, _b, _c;
  const errMessage = error.message.toLowerCase();
  if (errMessage.includes("unauthenticated") || errMessage.includes("unauthorized") || errMessage.includes("jwt malformed") || errMessage.includes("jwt expired") || errMessage.includes("unable to verify token")) {
    return new UnauthorizedError/* UnauthorizedError */.y(error.message);
  }
  if (((_a = error.extensions) == null ? void 0 : _a.code) === "BAD_USER_INPUT") {
    return new BadUserInputError(error.message);
  }
  if (((_b = error.extensions) == null ? void 0 : _b.code) === "INVALID_REQUEST_SIGNATURE" || ((_c = error.extensions) == null ? void 0 : _c.code) === "UNKNOWN_USER") {
    return new RequestSignatureError(error.message, error.extensions.code);
  }
  return error;
};
const extractAndNormalizeApolloError = (error) => {
  var _a, _b, _c;
  const graphqlErrors = (_a = error.graphQLErrors) != null ? _a : [];
  const serverError = (_b = error.networkError) == null ? void 0 : _b.result;
  const networkErrors = typeof serverError === "string" ? [serverError] : (_c = serverError == null ? void 0 : serverError.errors) != null ? _c : [];
  const normalizedErrors = [...graphqlErrors, ...networkErrors].map(
    normalizeError
  );
  return normalizedErrors[0];
};

// EXTERNAL MODULE: ./src/client/clinical-engine/consultation/data-sync/getPatientHistoryCacheUpdateFunction.tsx
var getPatientHistoryCacheUpdateFunction = __webpack_require__(79042);
;// CONCATENATED MODULE: ./src/client/clinical-engine/consultation/data-sync/ConsultationNetworkSync.ts



class ConsultationNetworkSync {
  static getInstance(mutate, territoryDataSharing) {
    if (!this._instance) {
      this._instance = new ConsultationNetworkSync(
        mutate,
        territoryDataSharing
      );
    }
    return this._instance;
  }
  constructor(mutate, territoryDataSharing) {
    this.territoryDataSharingFeatureFlag = territoryDataSharing;
    if (!mutate) {
      throw new Error(
        "Cannot instantiate NetworkSync for first time without mutation function"
      );
    }
    this.mutate = mutate;
  }
  async doSync(entry, instrumentationAttrs) {
    try {
      const updateFn = (0,getPatientHistoryCacheUpdateFunction/* getPatientHistoryCacheUpdateFunction */.$)(
        entry.variables.input.patientId,
        this.territoryDataSharingFeatureFlag
      );
      const res = await this.mutate({
        variables: entry.variables,
        fetchPolicy: entry.variables.dryRun ? "no-cache" : "network-only",
        context: {
          headers: {
            "x-idempotency-key": instrumentationAttrs.correlationId,
            ...entry.headers
          }
        },
        update: entry.variables.dryRun ? () => {
        } : updateFn
      });
      return res;
    } catch (e) {
      if (e instanceof errors/* ApolloError */.cA) {
        throw extractAndNormalizeApolloError(e);
      }
      throw e;
    }
  }
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+web-observability@2.0.1_typescript@4.7.3/node_modules/@elephant-healthcare/web-observability/dist/module.js
var web_observability_dist_module = __webpack_require__(97193);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/index.ts + 1 modules
var data_sync = __webpack_require__(19545);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/clinicalActivityStatus.ts
var clinicalActivityStatus = __webpack_require__(40802);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/ClinicalEventController.ts
var ClinicalEventController = __webpack_require__(80084);
// EXTERNAL MODULE: ./src/client/clinical-engine/consultation/data-sync/analytics.ts
var analytics = __webpack_require__(65012);
// EXTERNAL MODULE: ./src/client/clinical-engine/consultation/data-sync/ConsultationDataController.ts + 1 modules
var ConsultationDataController = __webpack_require__(77319);
;// CONCATENATED MODULE: ./src/client/clinical-engine/consultation/data-sync/ConsultationSyncStateController.ts









class ConsultationSyncStateController {
  constructor(emitAnalyticsEvent) {
    this.emitAnalyticsEvent = emitAnalyticsEvent;
    this.cachedEvents = /* @__PURE__ */ new Set();
    var _a;
    this.boundPendingHandler = this.handlePendingEvent.bind(this);
    emitAnalyticsEvent && this.emitAnalyticsEvent.bind(this);
    const eventController = ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance();
    eventController.registerPendingListener(
      data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
      this.boundPendingHandler
    );
    eventController.registerSuccessListener(
      data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
      this.handleSuccessEvent
    );
    eventController.registerFailureListener(
      data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
      this.handleFailureEvent
    );
    this.isOnline = web_observability_dist_module/* NetworkStatus.isOnline */.Ie.isOnline(
      navigator.connection,
      navigator.onLine
    );
    this.boundNetworkHandler = this.networkChangeHandler.bind(this);
    (_a = navigator.connection) == null ? void 0 : _a.addEventListener("change", this.boundNetworkHandler);
  }
  static getInstance(emitAnalyticsEvent) {
    if (!this._instance) {
      this._instance = new ConsultationSyncStateController(emitAnalyticsEvent);
    }
    return this._instance;
  }
  get online() {
    return this.isOnline;
  }
  networkChangeHandler(e) {
    if (!web_observability_dist_module/* NetworkStatus.isOnline */.Ie.isOnline(e.target, navigator.onLine)) {
      this.isOnline = false;
      return;
    }
    if (this.isOnline)
      return;
    this.isOnline = true;
    this.cachedEvents.forEach((event) => {
      this.boundPendingHandler(event);
    });
  }
  cachePendingEvent(event) {
    this.cachedEvents.add(event);
  }
  removePendingEvent(event) {
    this.cachedEvents.delete(event);
  }
  hasCachedEvent(e) {
    return this.cachedEvents.has(e);
  }
  async handlePendingEvent(event) {
    var _a;
    this.removePendingEvent(event);
    if (!this.isOnline) {
      this.cachePendingEvent(event);
      return;
    }
    const {
      data: { syncAttempt },
      key
    } = event;
    (_a = this.emitAnalyticsEvent) == null ? void 0 : _a.call(
      this,
      {
        name: `${analytics/* SUBMIT_LATER_NAME */.SW}.${analytics/* SUBMIT_LATER_EVENT.submit */.X6.submit}`,
        category: analytics/* SUBMIT_LATER_CATEGORY */.lD,
        syncAttempt,
        correlationId: key
      },
      true
    );
    const consultationData = await ConsultationDataController/* ConsultationDataController.getInstance */._.getInstance().readFromStore(key, key);
    if (!consultationData) {
      ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance().emit(data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION, {
        key,
        status: clinicalActivityStatus/* ClinicalActivityStatus.fail */.y.fail,
        severity: data_sync/* FailureSeverity.FATAL */.at.FATAL,
        error: new data_sync/* NotFoundError */.dR(
          `No data in persistent store for consultation with key ${key}`
        ),
        data: event.data
      });
      return;
    }
    setTimeout(() => {
      ConsultationNetworkSync.getInstance().doSync(consultationData.request, {
        correlationId: key
      }).then(() => {
        ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance().emit(
          data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
          {
            key,
            status: clinicalActivityStatus/* ClinicalActivityStatus.success */.y.success,
            data: event.data
          }
        );
      }).catch((err) => {
        const isFatal = err instanceof data_sync/* UnauthorizedError */.yj || err instanceof BadUserInputError || err instanceof RequestSignatureError;
        if (isFatal) {
          ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance().emit(
            data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
            {
              key,
              status: clinicalActivityStatus/* ClinicalActivityStatus.fail */.y.fail,
              severity: data_sync/* FailureSeverity.FATAL */.at.FATAL,
              error: err,
              data: event.data
            }
          );
        } else {
          ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance().emit(
            data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
            {
              key,
              status: clinicalActivityStatus/* ClinicalActivityStatus.fail */.y.fail,
              severity: data_sync/* FailureSeverity.ACCEPTABLE */.at.ACCEPTABLE,
              error: err,
              data: event.data
            }
          );
        }
      });
    }, Math.floor(Math.random() * (100 - 1 + 1) + 1));
  }
  async handleSuccessEvent(event) {
    var _a;
    const {
      key,
      data: { syncAttempt }
    } = event;
    await ConsultationDataController/* ConsultationDataController.getInstance */._.getInstance().deleteFromStore(key, key);
    (_a = this.emitAnalyticsEvent) == null ? void 0 : _a.call(
      this,
      {
        name: `${analytics/* SUBMIT_LATER_NAME */.SW}.${analytics/* SUBMIT_LATER_EVENT.success */.X6.success}`,
        category: analytics/* SUBMIT_LATER_CATEGORY */.lD,
        syncAttempt,
        correlationId: key
      },
      true
    );
  }
  async handleFailureEvent(event) {
    var _a;
    const {
      key,
      data: { syncAttempt, ...restData }
    } = event;
    switch (event.severity) {
      case data_sync/* FailureSeverity.FATAL */.at.FATAL:
        await ConsultationDataController/* ConsultationDataController.getInstance */._.getInstance().deleteFromStore(
          key,
          key
        );
        break;
      case data_sync/* FailureSeverity.ACCEPTABLE */.at.ACCEPTABLE:
        ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance().emit(
          data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
          {
            key,
            status: clinicalActivityStatus/* ClinicalActivityStatus.pending */.y.pending,
            data: {
              ...restData,
              syncAttempt: syncAttempt + 1
            }
          }
        );
        break;
      default:
        console.warn(
          "Consultation in failure state that is not handled. Get a handle on it..",
          {
            correlationId: event.key,
            cause: event.error
          }
        );
        break;
    }
    let errorIdentifier = "Unauthorized";
    if (event.error instanceof RequestSignatureError) {
      errorIdentifier = event.error.code;
    } else if (event.error instanceof data_sync/* NotFoundError */.dR) {
      errorIdentifier = "DataNotFound";
    }
    const isFatal = event.severity === data_sync/* FailureSeverity.FATAL */.at.FATAL;
    const errorNameSuffix = isFatal ? ".fatal" : "";
    (_a = this.emitAnalyticsEvent) == null ? void 0 : _a.call(
      this,
      {
        name: `${analytics/* SUBMIT_LATER_NAME */.SW}.${analytics/* SUBMIT_LATER_EVENT.failure */.X6.failure}${errorNameSuffix}`,
        category: analytics/* SUBMIT_LATER_CATEGORY */.lD,
        syncAttempt,
        correlationId: key,
        fatal: isFatal,
        error: isFatal ? errorIdentifier : event.error
      },
      true
    );
  }
}

// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/ClinicalSyncStatus.tsx + 1 modules
var ClinicalSyncStatus = __webpack_require__(75185);
;// CONCATENATED MODULE: ./src/client/clinical-engine/consultation/data-sync/useResumeConsultation.tsx







const useLazyResumeConsultation = () => {
  const apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  const { canPerformOfflineOperations } = (0,ClinicalSyncStatus/* useClinicalSyncStatusContext */.Tb)();
  return react.useCallback(async () => {
    if (!canPerformOfflineOperations) {
      return;
    }
    const dataController = ConsultationDataController/* ConsultationDataController.getInstance */._.getInstance(apolloClient);
    const allData = await dataController.readAllFromStore();
    const eventEmitter = ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance();
    allData.forEach(({ id: key, request: data }) => {
      eventEmitter.emit(data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION, {
        key,
        status: clinicalActivityStatus/* ClinicalActivityStatus.pending */.y.pending,
        data: data.syncDetails
      });
    });
  }, [apolloClient, canPerformOfflineOperations]);
};


;// CONCATENATED MODULE: ./src/client/clinical-engine/data-sync/cache/CacheAccessor.ts
class CacheAccessor {
  static getInstance(apolloClient) {
    if (!this._instance) {
      if (!apolloClient)
        throw new Error("Must provide ApolloClient on first instantiation");
      this._instance = new CacheAccessor(apolloClient);
    }
    return this._instance;
  }
  constructor(apolloClient) {
    this.apolloClient = apolloClient;
  }
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/client/observability/ObservabilityContext.ts
var ObservabilityContext = __webpack_require__(50527);
;// CONCATENATED MODULE: ./src/client/clinical-engine/consultation/data-sync/useSetupBackgroundConsultations.tsx










const useSetupBackgroundConsultations = () => {
  const apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  const [mutate] = (0,graphql_gql/* useCreateConsultationMutation */.Yv)();
  const { loading } = (0,launchdarkly_provider_dist_module/* useFeatureFlagContext */.dG)();
  const territoryDataSharing = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const resumeConsultations = useLazyResumeConsultation();
  const { emitAnalyticsEvent } = (0,ObservabilityContext/* useObservabilityContext */.V)();
  react.useEffect(() => {
    if (loading) {
      return;
    }
    CacheAccessor.getInstance(apolloClient);
    ConsultationNetworkSync.getInstance(mutate, territoryDataSharing);
    ConsultationSyncStateController.getInstance(emitAnalyticsEvent);
    resumeConsultations().catch(console.warn);
  }, [
    apolloClient,
    emitAnalyticsEvent,
    loading,
    mutate,
    resumeConsultations,
    territoryDataSharing
  ]);
  return null;
};

// EXTERNAL MODULE: ./src/client/compatibility/analytics.ts
var compatibility_analytics = __webpack_require__(17845);
;// CONCATENATED MODULE: ./src/client/compatibility/useStoragePermissions.ts



const ANALYTIC_NAME_INVALID = "browser.permissions.inValid";
const hasStoragePermissions = async () => {
  var _a;
  if ((_a = navigator.storage) == null ? void 0 : _a.persist) {
    const isPersisted = await navigator.storage.persisted();
    return isPersisted;
  }
  return false;
};
const useStoragePermissions = () => {
  const { emitAnalyticsEvent } = (0,ObservabilityContext/* useObservabilityContext */.V)();
  (0,react.useEffect)(() => {
    const doWork = async () => {
      const hasPermissions = await hasStoragePermissions();
      if (!hasPermissions) {
        emitAnalyticsEvent({
          name: ANALYTIC_NAME_INVALID,
          category: compatibility_analytics/* ANALYTIC_CATEGORY */.O
        });
      }
    };
    doWork();
  }, []);
  return null;
};
/* harmony default export */ const compatibility_useStoragePermissions = (useStoragePermissions);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
;// CONCATENATED MODULE: ./src/client/clinical-engine/useClinicalActivityNotifications.ts






const useClinicalActivityNotifications = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const clinicalEventController = ClinicalEventController/* ClinicalEventController.getInstance */.O.getInstance();
  const handleEvent = (eventData) => {
    switch (eventData.status) {
      case clinicalActivityStatus/* ClinicalActivityStatus.success */.y.success:
        dist_default().success(
          formatMessage({
            id: "Consultation.handleSubmit.success",
            defaultMessage: "Consultation is successfully saved!"
          })
        );
        break;
      default:
        break;
    }
  };
  (0,react.useEffect)(() => {
    clinicalEventController.addListener(
      data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
      handleEvent
    );
    return () => {
      clinicalEventController.removeListener(
        data_sync/* ClinicalTopics.CONSULTATION */.V.CONSULTATION,
        handleEvent
      );
    };
  });
};
/* harmony default export */ const clinical_engine_useClinicalActivityNotifications = (useClinicalActivityNotifications);

;// CONCATENATED MODULE: ./src/client/clinical-engine/index.tsx









const ClinicalEngine = react.memo(() => {
  const apollo = (0,useApolloClient/* useApolloClient */.x)();
  if (!apollo) {
    console.warn(
      "ClinicalEngine must be rendered within the Apollo Client provider"
    );
  }
  compatibility_useStoragePermissions();
  clinical_engine_useClinicalActivityNotifications();
  (0,useDiseases/* useDiseases */.g)();
  useMedications();
  useInvestigationActivities();
  usePatientTriageEvents();
  useSetupBackgroundConsultations();
  return null;
});


/***/ }),

/***/ 76361:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bT": () => (/* binding */ useActiveInvestigationActivitiesQuery),
/* harmony export */   "eW": () => (/* binding */ useActiveInvestigationActivitiesLazyQuery),
/* harmony export */   "oG": () => (/* binding */ useInvestigationsListHashQuery),
/* harmony export */   "yG": () => (/* binding */ ActiveInvestigationActivitiesDocument)
/* harmony export */ });
/* unused harmony exports InvestigationsListHashDocument, useInvestigationsListHashLazyQuery */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41552);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90322);


const defaultOptions = {};
const ActiveInvestigationActivitiesDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query ActiveInvestigationActivities {
  catalogueInvestigationActivities {
    id
    _id
    title
    keywords
    activityType
    meta {
      created
    }
    coding {
      elephant {
        code
      }
      loinc {
        code
      }
    }
    result {
      resultSchema
    }
  }
}
    `;
function useActiveInvestigationActivitiesQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a(ActiveInvestigationActivitiesDocument, options);
}
function useActiveInvestigationActivitiesLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useLazyQuery */ .t(ActiveInvestigationActivitiesDocument, options);
}
const InvestigationsListHashDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query InvestigationsListHash {
  catalogueInvestigationActivitiesLastUpdated
}
    `;
function useInvestigationsListHashQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a(InvestigationsListHashDocument, options);
}
function useInvestigationsListHashLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvestigationsListHashDocument, options);
}


/***/ }),

/***/ 34176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* binding */ InvestigationDataController)
});

// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
// EXTERNAL MODULE: ./src/client/clinical-engine/anc-encounter/graphql.ts
var graphql = __webpack_require__(31798);
;// CONCATENATED MODULE: ./src/client/clinical-engine/investigationActivities/data-sync/associateToAncEncounter.ts

const associateToAncEncounter = (apolloClient, newInvestigationRef, encounterId) => {
  apolloClient.cache.modify({
    id: apolloClient.cache.identify({
      id: encounterId,
      __typename: graphql/* default.typename */.Z.typename
    }),
    fields: {
      investigations(maybeExistingRefs, { canRead }) {
        if (canRead(newInvestigationRef)) {
          return [newInvestigationRef, ...maybeExistingRefs != null ? maybeExistingRefs : []];
        }
        return [...maybeExistingRefs != null ? maybeExistingRefs : []];
      }
    }
  });
};
/* harmony default export */ const data_sync_associateToAncEncounter = (associateToAncEncounter);

;// CONCATENATED MODULE: ./src/client/clinical-engine/investigationActivities/data-sync/associateToPatientHistory.ts
const associateToPatientHistory = (apolloClient, investigationRef) => {
  apolloClient.cache.modify({
    fields: {
      investigationActivitiesPaginatedOffset(input, { readField }) {
        const newId = readField("_id", investigationRef);
        if (input.items.some((ref) => readField("_id", ref) === newId)) {
          return input;
        }
        return {
          ...input,
          items: [...input.items, investigationRef],
          total: input.total + 1
        };
      }
    }
  });
};
/* harmony default export */ const data_sync_associateToPatientHistory = (associateToPatientHistory);

// EXTERNAL MODULE: ./src/client/apollo/client.ts + 2 modules
var client = __webpack_require__(77430);
// EXTERNAL MODULE: ./src/client/clinical-engine/investigationActivities/graphql.ts
var investigationActivities_graphql = __webpack_require__(18712);
;// CONCATENATED MODULE: ./src/client/clinical-engine/investigationActivities/data-sync/InvestigationDataController.ts





class InvestigationDataController {
  static getInstance(apolloClient) {
    if (!this._instance) {
      this._instance = new InvestigationDataController(apolloClient);
    }
    return this._instance;
  }
  constructor(apolloClient) {
    if (!apolloClient) {
      throw new Error(
        "Cannot instantiate InvestigationDataController for first time without apolloClient"
      );
    }
    this.apolloClient = apolloClient;
  }
  writeToCache(investigation) {
    var _a;
    const id = (0,client/* customDataIdFromObject */.Ux)(investigation);
    const newInvestigationRef = this.apolloClient.cache.writeFragment({
      id,
      data: investigation,
      fragment: investigationActivities_graphql/* default.fragments.investigationActivity */.Z.fragments.investigationActivity
    });
    data_sync_associateToPatientHistory(this.apolloClient, newInvestigationRef);
    if (((_a = investigation.clinicalEvent) == null ? void 0 : _a.type) === base_gql/* ClinicalEventType.AncEncounter */.gW.AncEncounter) {
      data_sync_associateToAncEncounter(
        this.apolloClient,
        newInvestigationRef,
        investigation.clinicalEvent.id
      );
    }
  }
  readFromCache() {
    throw new Error("Not implemented");
  }
  deleteFromCache() {
    throw new Error("Not implemented");
  }
  writeToStore() {
    return Promise.reject(Error("Not implemented"));
  }
  readFromStore() {
    return Promise.reject(Error("Not implemented"));
  }
  deleteFromStore() {
    return Promise.reject(Error("Not implemented"));
  }
}


/***/ }),

/***/ 18712:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);

const InvestigationActivityFragment = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  fragment InvestigationActivityFragment on InvestigationActivity {
    _id
    void
    meta {
      created
      updated
    }
    clinicalEvent {
      id
      type
    }
    catalogueItem {
      _id
      title
      activityType
      coding {
        elephant {
          code
        }
        loinc {
          code
        }
      }
      keywords
      result {
        resultSchema
      }
      meta {
        created
        updated
      }
    }
    request {
      _id
      meta {
        created
      }
      location {
        _id
        name
      }
      performer {
        _id
        name
      }
      organisation {
        uuid
        name
      }
      clinic {
        _id
        uuid
        name
      }
      orderedProperties
    }
    outcome {
      _id
      location {
        _id
        name
      }
      performer {
        _id
        name
      }
      organisation {
        uuid
        name
      }
      clinic {
        _id
        uuid
        name
      }
      meta {
        created
        updated
      }
      orderedProperties
    }
  }
`;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  fragments: {
    investigationActivity: InvestigationActivityFragment
  }
});


/***/ }),

/***/ 80540:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": () => (/* binding */ useActiveMedicationsQuery),
/* harmony export */   "L": () => (/* binding */ ActiveMedicationsDocument),
/* harmony export */   "Wp": () => (/* binding */ useMedicationListHashQuery),
/* harmony export */   "mu": () => (/* binding */ useActiveMedicationsLazyQuery)
/* harmony export */ });
/* unused harmony exports MedicationListHashDocument, useMedicationListHashLazyQuery */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41552);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90322);


const defaultOptions = {};
const ActiveMedicationsDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query ActiveMedications {
  medications {
    id
    items {
      id
      uuid
      genericName
      formulation
      strength
      keywords
    }
    listHash
  }
}
    `;
function useActiveMedicationsQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a(ActiveMedicationsDocument, options);
}
function useActiveMedicationsLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useLazyQuery */ .t(ActiveMedicationsDocument, options);
}
const MedicationListHashDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query MedicationListHash {
  medicationListHash
}
    `;
function useMedicationListHashQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a(MedicationListHashDocument, options);
}
function useMedicationListHashLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(MedicationListHashDocument, options);
}


/***/ }),

/***/ 65460:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eH": () => (/* binding */ linkToScanCard),
/* harmony export */   "fV": () => (/* binding */ linkToClinicianDashboard),
/* harmony export */   "rS": () => (/* binding */ CLINICIAN_ACTION_ROUTES),
/* harmony export */   "xG": () => (/* binding */ mostRecentClinicianActionLocationIndex)
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28183);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56824);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47279);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94015);
/* harmony import */ var elephant_web_client_ward_patient_list_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55036);
/* harmony import */ var elephant_web_client_patient_queue_management_links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32780);
/* harmony import */ var _patient_search_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87268);





const appendSearch = (params) => {
  return (0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(params, { addQueryPrefix: true });
};
function linkToClinicianDashboard(opts = {}) {
  const search = { ...opts };
  return `/clinician/dashboard${appendSearch(search)}`;
}
function linkToScanCard(opts = {}) {
  const search = { ...opts };
  return `/scan-card${appendSearch(search)}`;
}
const CLINICIAN_ACTION_ROUTES = [
  linkToClinicianDashboard(),
  (0,_patient_search_links__WEBPACK_IMPORTED_MODULE_3__/* .linkToPatientSearch */ .O)(),
  (0,elephant_web_client_patient_queue_management_links__WEBPACK_IMPORTED_MODULE_2__/* .linkToPatientQueue */ .b)(),
  linkToScanCard(),
  (0,elephant_web_client_ward_patient_list_links__WEBPACK_IMPORTED_MODULE_1__/* .linkToWardPatientList */ .P)()
];
const mostRecentClinicianActionLocationIndex = (locationList) => {
  const matchedLocationIndexes = CLINICIAN_ACTION_ROUTES.reduce((acc, url) => {
    const matchedIndex = (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("pathname", url))(locationList);
    if (matchedIndex >= 0) {
      return [...acc, matchedIndex];
    }
    return acc;
  }, []);
  if (matchedLocationIndexes.length) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Math.max, matchedLocationIndexes);
  }
  return -1;
};


/***/ }),

/***/ 88881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19036);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44450);
/* harmony import */ var elephant_web_style_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6729);




function ThemeProvider({ children }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    theme: elephant_web_style_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
  }, children);
}
ThemeProvider.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([
    prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_1___default().node)),
    (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node)
  ]).isRequired
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (react__WEBPACK_IMPORTED_MODULE_0__.memo(ThemeProvider));


/***/ }),

/***/ 52937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* reexport safe */ _featureFlags__WEBPACK_IMPORTED_MODULE_1__.Z),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45309);
/* harmony import */ var _featureFlags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96358);


function FeatureFlagGuard({ render, flagKey }) {
  const flag = (0,_elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_0__/* .useFeatureFlag */ .ye)(flagKey);
  if (flag) {
    return render();
  }
  return null;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FeatureFlagGuard);


/***/ }),

/***/ 96358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export defaultMockFlags */
const featureFlags = {
  antenatalCare: {
    actionButton: "antenatal-care.action-button"
  },
  consultation: {
    submitLater: "experiment.consultation-submit-later",
    showPresentingComplaintField: "rollout.consultation.showPresentingComplaintField"
  },
  billing: {
    master: "behaviour.billing.master",
    invoicing: "behaviour.billing.invoicing",
    payments: "behaviour.billing.invoicing.payments",
    blockRefunds: "behaviour.billing.invoicing.blockRefunds",
    exemption: "rollout.billing.exemption",
    blockWaive: "behaviour.billing.invoicing.blockWaive",
    usePriceListV2: "rollout.billing.invoicing.usePriceListV2"
  },
  patient: {
    history: {
      detailedReport: "rollout.patient.history.downloadDetailedReport",
      thermalPrintMedicationInstructions: "rollout.patient.history.thermal-print-medication-instructions",
      printPerConsultation: "experiment.patient-history.print-per-consultation"
    },
    territoryDataSharing: "patient-data-sharing.allowInterOrganisationSharing",
    useElasticSearch: "rollout.patient-search.useElasticsearch"
  },
  inventory: {
    permClinicalProductPermissions: "behaviour.stock.v3.clinical-product-edit-permission"
  },
  patientPay: "rollout.patient-pay",
  registers: {
    nigeriaDailyOutpatient: "rollout.register.nigeria-daily-outpatient",
    nigeriaGeneralAttendance: "rollout.register.nigeria-general-attendance"
  },
  appOutOfDateBanner: "rollout.appOutOfDateBanner",
  user: {
    whatsappConsent: "rollout.user.whatsapp-marketing-consent"
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (featureFlags);
const defaultMockFlags = {};


/***/ }),

/***/ 72766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OH": () => (/* reexport safe */ _elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_2__.OH),
/* harmony export */   "VH": () => (/* reexport safe */ _featureFlags__WEBPACK_IMPORTED_MODULE_0__.Z),
/* harmony export */   "dG": () => (/* reexport safe */ _elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_2__.dG),
/* harmony export */   "s3": () => (/* reexport safe */ _FeatureFlagGuard__WEBPACK_IMPORTED_MODULE_1__.Z),
/* harmony export */   "ye": () => (/* reexport safe */ _elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_2__.ye)
/* harmony export */ });
/* harmony import */ var _featureFlags__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96358);
/* harmony import */ var _FeatureFlagGuard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52937);
/* harmony import */ var _elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45309);





/***/ }),

/***/ 65267:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TranslationsProvider)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.7.2/node_modules/prop-types/index.js
var prop_types = __webpack_require__(19036);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/provider.js
var provider = __webpack_require__(60990);
// EXTERNAL MODULE: ./src/client/utils/useUserLanguage.jsx
var useUserLanguage = __webpack_require__(55541);
// EXTERNAL MODULE: ./src/client/common/i18n/usePersistUserLanguage.js
var usePersistUserLanguage = __webpack_require__(22518);
// EXTERNAL MODULE: ./src/client/utils/environment.ts
var environment = __webpack_require__(68490);
;// CONCATENATED MODULE: ./src/client/common/i18n/fetchTranslations.ts

const DEPLOYED_ASSET_BASE_PATH = "/monolith";
async function fetchTranslations(locale, logError = console.error) {
  const endPath = `/translations/${locale.toLowerCase()}.json`;
  const path = (0,environment/* isDeployedEnvironment */.m)() ? `${DEPLOYED_ASSET_BASE_PATH}${endPath}` : endPath;
  let output;
  try {
    output = await fetch(path);
  } catch (err) {
    logError({
      name: "fetchTranslations",
      error: new Error("Unable to fetch translations for locale"),
      locale: locale.toLowerCase(),
      err
    });
    return null;
  }
  if (output.status >= 400) {
    logError({
      name: "fetchTranslations.400",
      error: new Error("Unable to find translations for locale"),
      locale: locale.toLowerCase()
    });
    return null;
  }
  try {
    return await output.json();
  } catch (err) {
    logError({
      name: "fetchTranslations.json",
      error: new Error("Unable to parse translations for locale"),
      locale: locale.toLowerCase()
    });
    return null;
  }
}

// EXTERNAL MODULE: ./src/client/common/i18n/getSupportedLanguage.js
var getSupportedLanguage = __webpack_require__(16295);
// EXTERNAL MODULE: ./src/client/observability/ObservabilityContext.ts
var ObservabilityContext = __webpack_require__(50527);
;// CONCATENATED MODULE: ./src/client/common/i18n/TranslationsProvider.tsx








function TranslationsProvider({ children }) {
  const { emitErrorEvent } = (0,ObservabilityContext/* useObservabilityContext */.V)();
  const userLanguage = (0,useUserLanguage/* default */.ZP)();
  const language = (0,getSupportedLanguage/* default */.Z)(userLanguage);
  const [messages, setMessages] = react.useState();
  (0,usePersistUserLanguage/* default */.Z)(language);
  react.useEffect(() => {
    async function doFetchTranslations() {
      const newMessages = await fetchTranslations(language);
      if (newMessages) {
        setMessages(newMessages);
      }
    }
    doFetchTranslations();
  }, [language]);
  return /* @__PURE__ */ react.createElement(provider/* default */.Z, {
    locale: language,
    messages,
    onError: (err) => messages && !err.message.includes("using default message as fallback") && emitErrorEvent({ name: "TranslationsProvider", error: err })
  }, children);
}
TranslationsProvider.propTypes = {
  children: (prop_types_default()).node.isRequired
};


/***/ }),

/***/ 55046:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": () => (/* binding */ arabic),
/* harmony export */   "FK": () => (/* binding */ yoruba),
/* harmony export */   "FU": () => (/* binding */ english),
/* harmony export */   "KX": () => (/* binding */ igbo),
/* harmony export */   "OO": () => (/* binding */ swahili),
/* harmony export */   "P0": () => (/* binding */ kamba),
/* harmony export */   "V6": () => (/* binding */ french),
/* harmony export */   "YH": () => (/* binding */ other),
/* harmony export */   "bE": () => (/* binding */ PATIENT_LANGUAGE_CODES),
/* harmony export */   "d$": () => (/* binding */ USER_LANGUAGE_CODES),
/* harmony export */   "jY": () => (/* binding */ spanishMexico),
/* harmony export */   "mc": () => (/* binding */ OTHER_LANGUAGE_CODE),
/* harmony export */   "rv": () => (/* binding */ zabarmawa),
/* harmony export */   "s9": () => (/* binding */ NIGERIAN_PATIENT_LANGUAGE_CODES),
/* harmony export */   "zO": () => (/* binding */ fulani),
/* harmony export */   "zu": () => (/* binding */ hausa)
/* harmony export */ });
/* unused harmony exports asante, akuapem, gaDangme, ewe, dagbanli, gonja, kasem, nzema, fanteTwi, dagaare, frafra, kusase, waale, dagomba, mumprusi, konkomba, fulaniG, sisala, bimoba, mossi, chokosi, zabrama */
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11313);

const USER_LANGUAGE_CODES = {
  FRENCH: "fr",
  ENGLISH: "en-gb",
  SPANISH_MEXICO: "es-mx"
};
const PATIENT_LANGUAGE_CODES = {
  ARABIC: "ar",
  FRENCH: "fr",
  SWAHILI: "sw",
  ENGLISH: "en-gb",
  KAMBA: "kam"
};
const NIGERIAN_PATIENT_LANGUAGE_CODES = {
  FULANI: "fulani",
  HAUSA: "hausa",
  IGBO: "igbo",
  YORUBA: "yoruba",
  ZABARMAWA: "zabarmawa"
};
const arabic = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.arabic",
  defaultMessage: "Arabic"
});
const english = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.english",
  defaultMessage: "English"
});
const OTHER_LANGUAGE_CODE = "other";
const other = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.other",
  defaultMessage: "Other"
});
const french = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.french",
  defaultMessage: "French"
});
const kamba = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.kamba",
  defaultMessage: "Kamba"
});
const spanishMexico = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.spanishMexico",
  defaultMessage: "Spanish"
});
const swahili = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.swahili",
  defaultMessage: "Swahili"
});
const asante = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.asante",
  defaultMessage: "Asante Twi"
});
const akuapem = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.akuapem",
  defaultMessage: "Akuapem Twi"
});
const gaDangme = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.gaDangme",
  defaultMessage: "Ga Dangme"
});
const ewe = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.ewe",
  defaultMessage: "Ewe"
});
const dagbanli = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.dagbanli",
  defaultMessage: "Dagbanli"
});
const hausa = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.hausa",
  defaultMessage: "Hausa"
});
const gonja = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.gonja",
  defaultMessage: "Gonja"
});
const kasem = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.kasem",
  defaultMessage: "Kasem"
});
const nzema = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.nzema",
  defaultMessage: "Nzema"
});
const fanteTwi = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.fanteTwi",
  defaultMessage: "Fante Twi"
});
const dagaare = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.dagaare",
  defaultMessage: "Dagaare"
});
const frafra = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.frafra",
  defaultMessage: "Frafra"
});
const kusase = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.kusase",
  defaultMessage: "Kusase"
});
const waale = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.waale",
  defaultMessage: "Waale"
});
const dagomba = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.dagomba",
  defaultMessage: "Dagomba"
});
const mumprusi = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.mumprusi",
  defaultMessage: "Mumprusi"
});
const konkomba = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.konkomba",
  defaultMessage: "Konkomba"
});
const fulaniG = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.ghana.fulani",
  defaultMessage: "Fulani"
});
const sisala = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.sisala",
  defaultMessage: "Sisala"
});
const bimoba = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.bimoba",
  defaultMessage: "Bimoba"
});
const mossi = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.mossi",
  defaultMessage: "Mossi"
});
const chokosi = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.chokosi",
  defaultMessage: "Chokosi"
});
const zabrama = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.zabrama",
  defaultMessage: "Zabrama"
});
const fulani = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.fulani",
  defaultMessage: "Fulani"
});
const igbo = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.igbo",
  defaultMessage: "Igbo"
});
const yoruba = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.yoruba",
  defaultMessage: "Yoruba"
});
const zabarmawa = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "language.zabarmawa",
  defaultMessage: "Zabarmawa"
});


/***/ }),

/***/ 16295:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getSupportedLanguage)
/* harmony export */ });
/* unused harmony export findCloseSupportedLanguage */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55046);

const supportedLocales = Object.values(_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_LANGUAGE_CODES */ .d$);
function findCloseSupportedLanguage(locale, supportedLocalesList = supportedLocales) {
  if (!locale) {
    return null;
  }
  const lowerCaseLocale = locale == null ? void 0 : locale.toLocaleLowerCase();
  const lowerCaseSupportedLocales = supportedLocalesList.map(
    (l) => l == null ? void 0 : l.toLocaleLowerCase()
  );
  const fullMatchIndex = lowerCaseSupportedLocales.findIndex(
    (l) => l === lowerCaseLocale
  );
  if (fullMatchIndex >= 0) {
    return supportedLocalesList[fullMatchIndex];
  }
  const [language] = lowerCaseLocale.split("-");
  const languageMatchIndex = lowerCaseSupportedLocales.findIndex(
    (l) => l === language
  );
  if (languageMatchIndex >= 0) {
    return supportedLocalesList[languageMatchIndex];
  }
  return null;
}
function getSupportedLanguage(localeOrLocalesToCheck, supportedLocalesList = supportedLocales) {
  if (localeOrLocalesToCheck === "te-st") {
    return "te-st";
  }
  let locales = Array.isArray(localeOrLocalesToCheck) ? localeOrLocalesToCheck : [localeOrLocalesToCheck];
  locales = locales.map((locale) => {
    if (locale === "en" || (locale == null ? void 0 : locale.startsWith("en-"))) {
      return "en-gb";
    }
    return locale;
  });
  const localesWeSupport = locales.map((l) => findCloseSupportedLanguage(l, supportedLocalesList)).filter(Boolean);
  if (localesWeSupport.length) {
    return localesWeSupport[0];
  }
  return null;
}


/***/ }),

/***/ 59028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": () => (/* binding */ useMedicationFormulation),
/* harmony export */   "HC": () => (/* binding */ usePrescriptionLabel),
/* harmony export */   "K0": () => (/* binding */ useDurationUnits),
/* harmony export */   "OK": () => (/* binding */ getPrescriptionLabel),
/* harmony export */   "fN": () => (/* binding */ getMedicationCodification)
/* harmony export */ });
/* unused harmony exports durationUnits, getMedicationFormulation, useMedicationCodification */
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11313);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _components_Consultation_InitialForm_PrescriptionsSection_strings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82690);



const durationUnits = [
  { label: _components_Consultation_InitialForm_PrescriptionsSection_strings__WEBPACK_IMPORTED_MODULE_1__/* .frequencyMessages.day */ .P2.day, value: "day" },
  { label: _components_Consultation_InitialForm_PrescriptionsSection_strings__WEBPACK_IMPORTED_MODULE_1__/* .frequencyMessages.week */ .P2.week, value: "week" },
  { label: _components_Consultation_InitialForm_PrescriptionsSection_strings__WEBPACK_IMPORTED_MODULE_1__/* .frequencyMessages.month */ .P2.month, value: "month" }
];
const useDurationUnits = ({ uppercaseValues = false } = {}) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => durationUnits.map(({ value, label }) => ({
      value: uppercaseValues ? value.toUpperCase() : value,
      label: formatMessage(label, { value: 1 })
    })),
    [formatMessage, uppercaseValues]
  );
};
const unknownMedicationMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* .defineMessage */ .Em)({
  id: "medication.unknown",
  defaultMessage: "Unknown medication"
});
function getMedicationFormulation({
  medication = {},
  formatMessage
}) {
  var _a;
  const formulationMessage = _components_Consultation_InitialForm_PrescriptionsSection_strings__WEBPACK_IMPORTED_MODULE_1__/* .formulationMessages */ .gA[medication.formulation];
  const formulation = formulationMessage ? formatMessage(formulationMessage) : medication.formulation;
  const strength = (_a = medication == null ? void 0 : medication.strength) != null ? _a : "";
  return [strength, formulation].filter(Boolean).join(" ");
}
function getMedicationCodification({
  medication = {},
  formatMessage
}) {
  var _a;
  let formulation = getMedicationFormulation({ medication, formatMessage });
  if (formulation) {
    formulation = `(${formulation})`;
  }
  const medicationName = (_a = medication == null ? void 0 : medication.genericName) != null ? _a : formatMessage(unknownMedicationMessage);
  return [medicationName, formulation].filter(Boolean).join(" ");
}
function useMedicationFormulation(medication) {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return getMedicationFormulation({ medication, formatMessage });
}
function useMedicationCodification(medication) {
  const { formatMessage } = useIntl();
  return getMedicationCodification({ medication, formatMessage });
}
function getPrescriptionLabel(prescription, formatMessage) {
  const prescriptionLabel = getMedicationCodification({
    medication: prescription.medication || {},
    formatMessage
  });
  if (prescription.freeText) {
    return prescription.codification;
  }
  return prescriptionLabel;
}
function usePrescriptionLabel(prescription) {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return getPrescriptionLabel(prescription, formatMessage);
}


/***/ }),

/***/ 22518:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ usePersistUserLanguage),
/* harmony export */   "o": () => (/* binding */ getUserLanguage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_client_utils_globals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42359);


function getUserLanguage() {
  return elephant_web_client_utils_globals__WEBPACK_IMPORTED_MODULE_1__/* .sessionStorage.getItem */ .y7.getItem("user-language");
}
function usePersistUserLanguage(language) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    elephant_web_client_utils_globals__WEBPACK_IMPORTED_MODULE_1__/* .sessionStorage.setItem */ .y7.setItem("user-language", language);
  }, [language]);
}


/***/ }),

/***/ 10162:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gn": () => (/* binding */ isValidBrowserVersion),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports MINIMUM_CHROME_VERSION, isValidBrowserForFuture */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _observability_ObservabilityContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50527);
/* harmony import */ var _elephant_healthcare_web_observability__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97193);




var SupportedBrowsers = /* @__PURE__ */ ((SupportedBrowsers2) => {
  SupportedBrowsers2["chrome"] = "chrome";
  SupportedBrowsers2["unsupported"] = "unsupported";
  return SupportedBrowsers2;
})(SupportedBrowsers || {});
const MINIMUM_CHROME_VERSION = 61;
function isBrowserChrome(deviceInfo) {
  return deviceInfo["browser.name"].toLowerCase() === "chrome" /* chrome */;
}
function getBrowserMajorVersion(deviceInfo) {
  return Number(deviceInfo["browser.version"].split(".")[0]);
}
function isValidBrowserVersion() {
  const deviceInfo = (0,_elephant_healthcare_web_observability__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceMetaInformation */ .D7)();
  const isChrome = isBrowserChrome(deviceInfo);
  if (!isChrome)
    return false;
  const majorVersion = getBrowserMajorVersion(deviceInfo);
  return Math.max(majorVersion, MINIMUM_CHROME_VERSION) === majorVersion;
}
function isValidBrowserForFuture() {
  const isValid = isValidBrowserVersion();
  if (!isValid)
    return false;
  const deviceInfo = (0,_elephant_healthcare_web_observability__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceMetaInformation */ .D7)();
  const majorVersion = getBrowserMajorVersion(deviceInfo);
  return Math.max(majorVersion, 92) === majorVersion;
}
const ANALYTIC_NAME_INVALID = "browser.compatibility.inValid";
const ANALYTIC_NAME_INVALID_FUTURE = "browser.compatibility.future.inValid";
const BrowserSupport = () => {
  const isValid = isValidBrowserVersion();
  const isValidFuture = isValidBrowserForFuture();
  const { emitAnalyticsEvent } = (0,_observability_ObservabilityContext__WEBPACK_IMPORTED_MODULE_1__/* .useObservabilityContext */ .V)();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!isValid) {
      emitAnalyticsEvent == null ? void 0 : emitAnalyticsEvent({
        name: ANALYTIC_NAME_INVALID,
        category: _analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTIC_CATEGORY */ .O
      });
    }
    if (!isValidFuture) {
      emitAnalyticsEvent == null ? void 0 : emitAnalyticsEvent({
        name: ANALYTIC_NAME_INVALID_FUTURE,
        category: _analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTIC_CATEGORY */ .O
      });
    }
  }, [emitAnalyticsEvent, isValid, isValidFuture]);
  return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (react__WEBPACK_IMPORTED_MODULE_0__.memo(BrowserSupport));


/***/ }),

/***/ 17845:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ ANALYTIC_CATEGORY)
/* harmony export */ });
const ANALYTIC_CATEGORY = "compatibility";


/***/ })

}]);